<template>
  <div>
    <!-- 第一种类型 -->
    <template v-if="index === 1">
      <template v-if="len === 1">
        <svg
          version="1.1"
          class="flower_type_1 flower_type"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <g>
            <path
              @click.stop="clickHandle(1, 1)"
              class="st471"
              d="M70.39,250.36c-2.11-11.29-1.27-22.7-0.71-33.99c1.77-35.87,13.17-68.48,35.45-96.8
            c30.16-38.35,69.71-60.34,118.34-64.77c90.12-8.22,169.06,53.89,182.83,143.44c2.66,17.29,3.37,34.7,1.19,52.14
            c-2,4.16-1.42,8.82-2.56,13.18c-1.24,4.72-2.36,9.47-4.04,14.05c-24.52,66.6-72.11,105.57-142.13,115.2
            c-49.28,6.77-93.2-8.15-131.24-40.06c-26.17-21.95-42.99-49.99-52.88-82.45C72.65,263.76,72.57,256.84,70.39,250.36z"
            />
            <path
              class="st472"
              d="M70.39,250.36c2.76,0.4,1.92,3.06,2.17,4.4c4.66,24.75,14.48,47.26,29.17,67.6
            c25.85,35.78,60.8,57.7,103.78,66.88c12.46,2.66,25.2,4.3,37.96,3.63c36.96-1.96,70.47-13.37,99.92-36.43
            c34.17-26.75,53.92-61.92,62.52-103.92c0.32-1.55,0.28-3.16,0.41-4.88c0.38,0.4,0.75,0.63,0.85,0.94c0.19,0.57,0.22,1.19,0.32,1.8
            c-2.77,40.79-18.39,76.24-47.21,104.85c-48.25,47.88-106.36,63.53-171.28,43.53C124.25,378.8,86.02,332.87,72.13,266.69
            C71.01,261.36,70.1,255.9,70.39,250.36z"
            />
          </g>
        </svg>
      </template>
      <template v-if="len === 2">
        <svg
          version="1.1"
          class="flower_type_1 flower_type"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <g>
            <path
              class="flower_type_1_color1"
              @click.stop="clickHandle(1, 1)"
              d="M56.57,247.44c-2.16-11.77-1.33-23.67-0.7-35.45c1.96-37.2,14.02-70.94,37.44-100.03
            c31.02-38.51,71.34-60.3,120.74-64.89c3.75-1.19,7.71,0.34,11.45-0.88c0.37-0.07,0.74-0.06,1.11,0.02
            c2.86,2.93,1.93,6.65,1.94,10.09c0.04,107.55,0.03,215.09,0.04,322.64c0,4.16-0.05,8.32,0.05,12.46c-0.26,4.12-3.5,3.65-6.02,3.5
            c-39.61-2.37-75.07-15.53-105.75-40.99c-27.06-22.45-44.88-50.96-55.45-84.28C59.11,262.38,58.92,254.68,56.57,247.44z"
            />
            <path
              class="flower_type_1_color2"
              @click.stop="clickHandle(1, 2)"
              d="M234.23,46.21c76.49,2.57,144.44,54.2,163.7,133.22c5.17,21.23,5.42,42.8,4.75,64.45
            c-0.04,1.2-0.55,2.39-0.84,3.59c-2.4,9.93-3.84,20.05-7.11,29.82c-21.91,65.36-85.16,113.66-153.76,117.14
            c-5.73,0.29-6.87-0.71-7.26-6.6c-0.18-2.7-0.08-5.41-0.08-8.12c-0.03-109.33,0.05-218.65-0.04-327.98
            C233.59,49.86,233.29,47.96,234.23,46.21z"
            />
            <path
              class="st472"
              d="M234.23,46.21c1.76,2.64,1.19,5.63,1.19,8.51c0.02,110.36,0.05,220.71-0.09,331.07
            c-0.01,5.66,0.35,7.35,7.26,6.79c38.4-3.12,71.73-17.48,100.79-42.53c31.16-26.86,48.95-61.15,56.94-101.01
            c0.28-1.38,0.19-2.82,0.28-4.33c1.44,0.63,0.82,1.91,1.24,2.77c-2.83,41.78-18.83,78.08-48.35,107.38
            c-49.42,49.04-108.94,65.07-175.43,44.58c-66.32-20.44-105.48-67.48-119.71-135.26c-1.15-5.46-2.08-11.05-1.78-16.72
            c2.83,0.4,1.96,3.13,2.22,4.49c4.78,25.53,14.96,48.73,30.16,69.66c26.38,36.33,62.03,58.53,105.68,68.09
            c10.91,2.39,22.08,3.11,33.2,3.89c1.37-2.77,0.74-5.74,0.74-8.61c0.04-109.53,0.02-219.07,0.07-328.6c0-3.44-0.95-7.18,2.03-10.06
            C231.85,46.27,233.04,46.24,234.23,46.21z"
            />
            <path
              class="st475"
              d="M230.66,46.3c-0.02,113.43-0.02,226.86-0.14,340.29c0,2.41,2,6.16-2.7,6.98c-1.43-2.94-1.03-6.1-1.03-9.2
            c-0.01-109.81-0.01-219.61-0.02-329.42c0-2.91-0.11-5.82-0.17-8.73C227.96,46.24,229.31,46.27,230.66,46.3z"
            />
            <path
              class="st475"
              d="M225.5,46.19c-3.7,1.86-7.61,0.95-11.45,0.88C217.75,45.26,221.65,46.04,225.5,46.19z"
            />
          </g>
        </svg>
      </template>
      <template v-if="len === 3">
        <svg
          version="1.1"
          class="flower_type_1 flower_type"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <g>
            <path
              class="flower_type_1_color1"
              @click.stop="clickHandle(1, 1)"
              d="M54.06,250.38c-2.18-11.89-1.34-23.9-0.71-35.8c1.97-37.56,14.15-71.62,37.75-101.05
            c31.11-38.8,71.68-60.71,121.23-65.79c4.59-0.47,9.21-0.62,13.82-0.91c3.81,1.72,2.99,5.23,3,8.24c0.09,21.67,0.04,43.34,0.04,65
            c0,31.34-0.23,62.69,0.16,94.03c0.1,8.02-2.83,12.78-9.57,16.71c-43.77,25.57-87.09,51.89-130.57,77.94
            c-3.06,1.83-6.21,3.55-8.97,5.85c-3.9,0.73-4.26-2.81-5.42-4.89c-9.84-17.72-17.33-36.31-19.85-56.61
            C54.86,252.15,55.31,250.96,54.06,250.38z"
            />
            <path
              class="flower_type_1_color2"
              @click.stop="clickHandle(1, 2)"
              d="M233.82,46.84c77.38,2.6,146.14,54.81,165.63,134.74c5.24,21.47,5.48,43.29,4.8,65.19
            c-0.04,1.22-0.56,2.42-0.85,3.63c-1.93,5.52-1.96,11.42-3.4,17.04c-4.14,16.24-10.65,31.49-19.33,45.8
            c-4.04,6.66-6.07,7.12-12.66,2.76c-42.47-28.14-85.36-55.65-127.82-83.82c-4.62-3.06-6.97-6.59-6.97-12.37
            c0.06-56.63,0.23-113.27-0.02-169.9C233.21,48.84,233.28,47.8,233.82,46.84z"
            />
            <path
              class="st472"
              d="M233.82,46.84c1.67,2.46,1.21,5.26,1.21,7.97c0.01,54.94,0.07,109.88-0.09,164.82
            c-0.01,4.91,1.3,7.9,5.59,10.7c43.45,28.28,86.76,56.79,130.05,85.32c2.74,1.8,4.86,3.31,7.15-0.51
            c12.54-20.9,21.18-43.21,24.6-67.43c0.25,0.27,0.63,0.51,0.74,0.83c0.2,0.59,0.23,1.24,0.33,1.86
            c-2.87,42.26-19.05,78.98-48.92,108.61c-50,49.6-110.22,65.81-177.49,45.09c-67.11-20.67-106.72-68.25-121.12-136.81
            c-1.16-5.52-2.1-11.18-1.8-16.91c3.06-0.3,1.61,2.37,1.81,3.35c4.3,21.71,12.25,41.98,23.56,60.97
            c47.9-28.52,95.8-57.05,143.63-85.68c4.38-2.62,5.8-5.81,5.78-10.79c-0.15-54.52-0.11-109.04-0.05-163.56c0-2.61-1-5.53,1.42-7.75
            C231.42,46.89,232.62,46.87,233.82,46.84z"
            />
            <path
              class="st473"
              d="M230.22,46.91c-0.02,57.73-0.13,115.46,0.06,173.2c0.02,5.21-1.83,7.82-6.1,10.35
            c-46.32,27.49-92.52,55.18-138.79,82.75c-1.73,1.03-3.3,3.77-5.96,1.48c0.04-2.24,1.61-3.16,3.31-4.18
            c45.31-27.05,90.52-54.26,135.97-81.06c6.41-3.78,8.91-7.81,8.86-15.38c-0.35-53.09-0.18-106.19-0.2-159.28
            c0-2.7,0.51-5.52-1.23-7.96C227.5,46.86,228.86,46.88,230.22,46.91z"
            />
            <path
              class="flower_type_1_color3"
              @click.stop="clickHandle(1, 3)"
              d="M370.42,324.89c-5.76,10.14-13.63,18.59-22.21,26.23c-13.68,12.18-28.67,22.59-45.44,30.22
            c-19.05,8.67-38.89,13.82-59.86,15.68c-34.76,3.09-67.1-4.28-97.59-20.47c-23.69-12.58-43.42-29.85-59.12-51.74
            c-3.02-4.21-2.45-6.23,1.72-8.69c44.78-26.52,89.5-53.14,134.23-79.75c2.7-1.61,5.3-3.37,7.95-5.06c12.71,7.82,25,16.3,37.46,24.49
            c32.31,21.25,64.88,42.11,96.97,63.69C366.74,320.98,369.52,321.94,370.42,324.89z"
            />
            <path
              class="st474"
              d="M370.42,324.89c-20.52-13.44-41.04-26.88-61.56-40.31c-24.56-16.07-49.13-32.12-73.65-48.25
            c-1.98-1.3-4.82-1.92-5.11-5.01c2.8-2.21,4.71,0.17,6.67,1.45c39.56,25.88,79.08,51.81,118.62,77.72c4.74,3.11,9.48,6.22,14.3,9.22
            C372.17,321.23,373.13,322.74,370.42,324.89z"
            />
          </g>
        </svg>
      </template>
    </template>

    <!-- 第二种类型 -->
    <template v-if="index === 2">
      <template v-if="len === 1">
        <svg
          version="1.1"
          class="flower_type_2 flower_type"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <g>
            <path
              class="st44"
              d="M343.32,172.9c-0.32,12.13-3.6,23.63-8.17,34.7c-30.7,74.4-61.58,148.72-92.28,223.12
		c-1.99,4.82-5.42,8.2-8.89,11.71c-6.24,0-12.48,0-18.72,0c-5.63-4.38-8.51-10.47-11.14-16.93
		c-29.62-72.72-59.41-145.37-89.04-218.09c-4.39-10.76-7.61-21.89-8.07-33.65c-0.47-2.23-1.03-4.46,0.34-6.59
		c1.96,0.03,2,1.74,2.29,2.95c5.17,21.77,15.11,41.76,23.38,62.35c13.2,32.85,26.72,65.58,40.19,98.33
		c11.48,27.93,22.79,55.94,34.34,83.84c4.83,11.67,15.6,15.9,25.65,10.46c4.25-2.3,6.54-6.12,8.32-10.32
		c4.8-11.35,9.44-22.77,14.16-34.15c25.99-62.69,52.02-125.36,77.97-188.07c2.72-6.58,4.66-13.44,6.41-20.35
		c0.47-1.85,0.22-4.29,2.79-5.06C344.3,168.96,343.63,170.95,343.32,172.9z"
            />
            <path
              class="st43"
              @click.stop="clickHandle(2, 1)"
              d="M342.18,167.36c-1.53,11.44-5.75,22.03-10.12,32.59c-20.04,48.44-40.05,96.9-60.09,145.34
		c-9.39,22.7-18.78,45.41-28.26,68.07c-2.28,5.44-4.74,10.75-10.7,13.47c-10.16,4.64-21.71,0.6-25.97-9.74
		c-13.25-32.15-26.32-64.38-39.49-96.56c-15.01-36.67-30.12-73.29-45.03-110c-5.2-12.8-11.05-25.4-13.84-39.07
		c-0.27-1.35-0.39-2.73-0.58-4.09c-2.07-2.45-1.02-5.6-1.86-8.33c-2.2-52.95,18.34-93.76,65.71-118.59
		c69.75-36.56,157,7.64,170.32,85.42c1.89,11.02,2.16,22.06,1.77,33.17C343.19,161.76,344.23,164.91,342.18,167.36z"
            />
            <path
              class="st64"
              d="M106.24,159.03c1.22,2.64,1.49,5.49,1.86,8.33c-1.87,1.88-0.44,4.32-1.09,6.41
		C105.55,168.91,106.08,163.96,106.24,159.03z"
            />
            <path
              class="st65"
              d="M342.18,167.36c0.36-2.83,0.63-5.69,1.85-8.32c0.12,4.64,0.7,9.3-0.72,13.86
		C342.71,171.1,343.89,168.93,342.18,167.36z"
            />
          </g>
        </svg>
      </template>
      <template v-if="len === 2">
        <svg
          version="1.1"
          class="flower_type_2 flower_type"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <g>
            <path
              class="flower_type_2_color1"
              @click.stop="clickHandle(2, 2)"
              d="M230.78,22.26c48.12-0.91,96.28,29.93,113.69,81.15c5.44,16,6.99,32.47,6.12,49.25
		c-0.45,3.36-0.71,6.73-0.87,10.12c-0.77,8.38-3.1,16.4-6.29,24.1c-25.06,60.57-50.25,121.08-75.39,181.62
		c-5.47,13.17-11.02,26.3-16.37,39.51c-2.36,5.81-4.9,11.58-10.97,14.71c-6.15,3.16-8.16,2.04-8.34-4.81
		c-0.06-2.09-0.02-4.17-0.02-6.26c0-126.42,0.01-252.83-0.05-379.25c0-2.82,1.09-5.96-1.34-8.45
		C230.52,23.42,230.47,22.86,230.78,22.26z"
            />
            <path
              class="flower_type_2_color2"
              @click.stop="clickHandle(2, 1)"
              d="M111.91,153.68c-2.3-48.45,15.49-87.02,56.64-113.67c17.82-11.54,37.69-17.27,58.99-17.72
		c1.88,1.78,1.6,4.12,1.6,6.36c0.01,129.78,0.02,259.57,0,389.35c0,1.39,0.06,2.79-0.3,4.14c-0.84,2.94-2.97,2.4-5.01,1.72
		c-6.22-2.06-10.07-6.55-12.52-12.43c-5.35-12.82-10.59-25.69-15.83-38.56c-25.42-62.4-51.27-124.63-76.51-187.1
		c-3.06-7.57-5.59-15.31-6.19-23.54C112.63,159.36,112.39,156.51,111.91,153.68z"
            />
            <path
              class="st455"
              d="M113.79,162.02c1.37,11.52,5.86,22.07,10.17,32.66c15.51,38.07,31.08,76.12,46.66,114.16
		c13.61,33.23,27.38,66.39,40.84,99.68c3.16,7.81,7.79,13.42,16.23,15.3c2.16-1.93,1.45-4.52,1.45-6.87
		c0.04-55.96,0.03-111.93,0.03-167.89c0-72.65-0.01-145.3,0.03-217.95c0-2.7-0.73-5.63,1.62-7.89c1.81-0.16,3.1,0.27,3.04,2.46
		c-0.05,1.56,0.01,3.13,0.01,4.7c0,129.09,0,258.17,0,387.26c0,6.54,0.52,6.76,6.51,3.63c5.61-2.93,7.68-8.39,9.87-13.63
		c18.7-44.83,37.5-89.62,55.82-134.6c12.95-31.81,27.14-63.11,38.92-95.39c1.84-5.04,3.28-10.23,3.75-15.62
		c3.05,1.68,1.08,4.23,1.11,6.43c-0.44,11.78-3.63,22.98-8.08,33.74c-30.88,74.69-61.96,149.3-92.9,223.96
		c-3.42,8.25-9.32,13.12-18.2,13.11c-8.88-0.02-14.8-4.95-18.17-13.18c-30.69-74.95-61.49-149.86-92.09-224.85
		c-4.26-10.45-7.31-21.34-7.7-32.77C112.71,166.24,110.73,163.69,113.79,162.02z"
            />
            <path
              class="st461"
              d="M230.82,23.22c-0.03,18.77-0.08,37.53-0.08,56.3c-0.01,112.95,0.01,225.91-0.09,338.86
		c0,1.99,2,5.83-2.95,5.44c-0.03-2.43-0.09-4.87-0.09-7.3c-0.02-131.41-0.04-262.82-0.06-394.24c1.08-0.01,2.16-0.02,3.23-0.03
		C230.76,22.58,230.77,22.9,230.82,23.22z"
            />
            <path
              class="st462"
              d="M349.83,168.45c-0.68-2.09,0.77-4.55-1.11-6.43c0.62-3.12,1.24-6.25,1.87-9.37
		C350.75,157.94,351.32,163.24,349.83,168.45z"
            />
            <path
              class="st457"
              d="M113.79,162.02c-1.89,1.88-0.43,4.34-1.11,6.43c-1.48-4.86-0.93-9.82-0.77-14.77
		C113.15,156.32,113.41,159.18,113.79,162.02z"
            />
          </g>
        </svg>
      </template>
      <template v-else-if="len === 3">
        <svg
          version="1.1"
          class="flower_type_2 flower_type"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <g>
            <path
              class="flower_type_2_color1"
              @click.stop="clickHandle(2, 1)"
              d="M117.55,153.19c-2.29-48.15,15.4-86.51,56.32-112.97c18.33-11.86,38.78-17.59,60.71-17.64
		c1.54,1.46,1.59,3.37,1.59,5.29c-0.01,53.77,0.07,107.54-0.04,161.31c0,0.52-0.11,1.03-0.19,1.53c-0.48,2.45-2.31,3.7-4.32,4.82
		c-25.37,14.09-50.85,27.96-76.37,41.77c-7.52,4.07-7.7,3.81-11.08-4.27c-6.74-16.1-13.35-32.25-19.79-48.46
		c-2.93-7.38-5.39-14.92-5.95-22.94C118.23,158.8,118.03,155.98,117.55,153.19z"
            />
            <path
              class="flower_type_2_color2"
              @click.stop="clickHandle(2, 2)"
              d="M237.78,22.58c36.67,0.71,66.78,15.37,90.16,43.38c21.04,25.21,28.75,54.82,26.86,87.24
		c-0.48,2.81-0.72,5.65-0.87,8.5c-0.64,7.78-2.8,15.2-5.65,22.38c-6.98,17.59-14.32,35.04-21.7,52.47c-0.4,0.96-0.93,1.85-1.74,2.53
		c-2.78,1.85-4.98-0.04-7.15-1.27c-19.08-10.84-38.18-21.63-57.23-32.51c-5.55-3.17-11.11-6.31-16.62-9.55
		c-2.97-1.75-4.48-4.17-4.46-7.61c0.01-1.9-0.03-3.8-0.03-5.7c0-50.28,0.02-100.57-0.05-150.85c0-2.48,0.9-5.25-1.36-7.36
		C237.52,23.73,237.47,23.17,237.78,22.58z"
            />
            <path
              class="st455"
              d="M324.88,238.17c5.93-14.63,11.8-29.28,17.82-43.88c4.39-10.64,8.7-21.29,10.26-32.81
		c2.88,1.32,1.14,3.6,1.13,5.51c-0.33,12.08-3.6,23.54-8.16,34.56c-30.65,74.11-61.49,148.15-92.19,222.24
		c-3.39,8.19-9.15,12.89-17.99,13.27c-8.08,0.34-14.77-4.75-18.36-13.5c-30.43-74.2-60.9-148.39-91.22-222.64
		c-4.31-10.56-7.44-21.53-7.86-33.07c0.03-2.19-1.94-4.72,1.11-6.39c1.34,10.52,5.16,20.27,9.19,29.98
		c6.13,14.78,12.19,29.59,18.13,44.45c1.05,2.62,1.92,3.48,4.71,1.95c21.28-11.71,42.63-23.29,63.96-34.9
		c6.35-3.46,12.73-6.87,19.1-10.3c2.44,3.49-0.16,4.97-2.65,6.29c-9.01,4.77-17.89,9.8-26.94,14.48
		c-17.04,8.81-33.67,18.38-50.78,27.07c-1.54,0.78-3.86,1.09-3.66,3.71c2.32,2.47,3.47,5.55,4.7,8.6
		c20.83,51.43,42.15,102.67,63.06,154.07c4.92,12.09,15.4,16.63,25.66,11.37c4.48-2.29,6.86-6.24,8.69-10.59
		c4.82-11.48,9.53-23,14.32-34.49c17.1-41,34.09-82.05,51.13-123.08c0.46-1.12,0.98-2.21,1.56-3.27c0.72-1.29,1.45-2.57,2.08-3.91
		C322.41,241.09,323.88,239.79,324.88,238.17z"
            />
            <path
              class="st456"
              d="M148.49,244.44c-1.33-3.26,1.9-3.29,3.28-4.05c14.94-8.18,29.99-16.16,45.02-24.19
		c11.53-6.16,23.05-12.36,34.64-18.42c2.23-1.17,3.74-2.4,3.08-5.13c0.02-56.69,0.04-113.39,0.06-170.08c1.07,0,2.14,0,3.21,0.01
		c-0.01,0.32,0,0.64,0.04,0.96c2.05,2.57,1.38,5.62,1.39,8.5c0.04,51.51,0.09,103.03-0.07,154.54c-0.02,4.87,1.25,7.71,5.72,10.21
		c23.22,12.98,46.18,26.44,69.29,39.64c3.22,1.84,7.13,3,8.65,6.99c-0.68,1.03-1.37,2.07-2.05,3.1c-7.31-1.5-12.87-6.45-19.1-9.97
		c-19.82-11.19-39.39-22.83-59.11-34.18c-3.4-1.96-6.25-2.07-9.65-0.28c-23.51,12.35-46.77,25.15-70.28,37.48
		C158.21,241.86,154.32,246.13,148.49,244.44z"
            />
            <path
              class="st457"
              d="M119.42,161.47c-1.88,1.87-0.42,4.31-1.11,6.39c-1.47-4.83-0.92-9.76-0.76-14.68
		C118.78,155.81,119.03,158.66,119.42,161.47z"
            />
            <path
              class="st458"
              d="M354.09,167c-0.6-1.79,0.58-3.95-1.13-5.51c0.36-2.82,0.63-5.66,1.85-8.29
		C354.93,157.82,355.5,162.46,354.09,167z"
            />
            <path
              class="st455"
              d="M322.79,243.42c-17.14-9.96-34.27-19.95-51.43-29.87c-10.15-5.87-20.3-11.76-30.6-17.35
		c-2.91-1.58-3.06-3.68-3.05-6.38c0.05-18.48,0.02-36.95,0.03-55.43c0.02-36.95,0.06-73.9,0.09-110.85c1.8-0.16,3.08,0.28,3.01,2.45
		c-0.04,1.38,0.01,2.76,0.01,4.15c0,51.84,0.04,103.67-0.07,155.51c-0.01,4.5,0.78,7.37,5.27,9.85
		c25.18,13.94,50.11,28.34,75.08,42.67c1.47,0.84,2.5,0.81,3.76,0C324.19,239.92,323.49,241.67,322.79,243.42z"
            />
            <path
              class="flower_type_2_color3"
              @click.stop="clickHandle(2, 3)"
              d="M148.49,244.44c4.7-0.27,8.36-3.14,12.26-5.21c23.6-12.51,47.17-25.09,70.61-37.9
		c4.64-2.53,8.06-2.35,12.71,0.4c25.04,14.83,50.35,29.2,75.55,43.74c0.43,0.25,0.75,0.69,1.11,1.04
		c-7.85,19.12-15.66,38.26-23.55,57.36c-14.08,34.08-28.17,68.16-42.36,102.2c-2.25,5.4-4.62,10.76-10.52,13.56
		c-10.35,4.89-21.91,0.83-26.26-9.76c-13.29-32.36-26.44-64.77-39.67-97.16c-8.67-21.22-17.41-42.4-26.04-63.64
		C151.52,247.04,150.05,245.76,148.49,244.44z"
            />
          </g>
        </svg>
      </template>
    </template>

    <!-- 第三种类型 -->
    <template v-if="index === 3">
      <template v-if="len === 1">
        <svg
          version="1.1"
          class="flower_type_3 flower_type"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <g>
            <path
              class="st465"
              d="M17.33,416.5c0-4.3,0-8.61,0-12.91c0.68-0.44,1.29-0.35,1.83,0.25c0.82,1.22,1.04,2.6,1.14,4.02
		c-0.09,2.81,0.45,5.71-1.1,8.32C18.66,416.82,18.04,416.92,17.33,416.5z"
            />
            <path
              class="st466"
              d="M18.46,403.65c-0.38,0.01-0.75-0.01-1.13-0.06c0-2.15,0-4.3,0-6.45c0.37-0.06,0.74-0.08,1.12-0.07
		C20.52,399.26,20.51,401.45,18.46,403.65z"
            />
            <path
              class="st467"
              d="M17.33,416.5c0.35-0.1,0.7-0.13,1.06-0.08c2.16,2.19,2.14,4.4,0.05,6.62c-0.37,0.03-0.74,0-1.1-0.08
		C17.33,420.8,17.33,418.65,17.33,416.5z"
            />
            <path
              @click.stop="clickHandle(3, 1)"
              class="st417"
              d="M18.46,403.65c0-2.2,0-4.39-0.01-6.59c3.59-14.01,10.38-26.78,15.84-40.04
		c19.14-46.42,38.6-92.71,58.06-139.01c15.88-37.79,30.58-76.14,48.24-113.09c21.89-45.8,59.89-72.77,109.77-80.38
		c79.39-12.13,152.52,40.81,167.26,119.32c2.6,13.82,2.76,27.71,2.33,41.67c-0.73,3.81-0.67,7.7-1.13,11.54
		c-3.89,27.69-16.43,51.29-34.43,72.2c-17.69,20.54-40.36,33.72-65.18,43.82c-76.84,31.26-153.35,63.33-230.09,94.85
		c-11.73,4.82-23.44,9.68-35.17,14.49c-6.43,2.64-13,4.4-20.04,1.84c-8.04-2.93-13.76-7.76-15.08-16.67
		C18.71,406.3,18.59,404.97,18.46,403.65z"
            />
            <path
              class="st418"
              d="M18.83,407.62c3.96,9.08,10.49,15.25,20.54,16.3c7.73,0.81,14.54-3.17,21.43-5.99
		c33.53-13.75,67.01-27.6,100.49-41.46c39.42-16.33,78.82-32.71,118.22-49.08c19.21-7.98,38.8-15.05,57.48-24.27
		c40.72-20.09,66.35-52.61,78.64-95.99c0.93-3.27,1.3-6.7,1.92-10.06c3.47,1.6,1.61,4.3,1.39,6.67
		c-1.94,29.02-12.93,54.49-30.56,77.3c-18.74,24.26-43.94,39.04-71.91,50.47c-88.29,36.07-176.35,72.71-264.53,109.07
		c-15.47,6.38-29.62-1.15-33.52-17.53c-0.02-2.21-0.03-4.41-0.04-6.62C18.54,413.48,18.68,410.55,18.83,407.62z"
            />
            <path
              class="st468"
              d="M418.94,203.73c-0.57-2.2,0.8-4.8-1.39-6.67c0.71-3.86,0.75-7.86,2.39-11.52
		C419.89,191.62,421.05,197.77,418.94,203.73z"
            />
          </g>
        </svg>
      </template>
      <template v-if="len === 2">
        <svg
          version="1.1"
          class="flower_type_3 flower_type"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <g>
            <path
              class="st465"
              d="M20.87,416.99c0-4.3,0-8.6,0-12.89c0.68-0.43,1.29-0.35,1.83,0.25c0.82,1.22,1.04,2.6,1.13,4.02
		c-0.09,2.81,0.45,5.7-1.1,8.31C22.2,417.31,21.58,417.42,20.87,416.99z"
            />
            <path
              class="st466"
              d="M22,404.16c-0.38,0.01-0.75-0.01-1.13-0.06c0-2.15,0-4.3,0-6.45c0.37-0.06,0.74-0.08,1.12-0.07
		C24.05,399.77,24.05,401.96,22,404.16z"
            />
            <path
              class="st467"
              d="M20.87,416.99c0.35-0.1,0.7-0.13,1.05-0.08c2.16,2.19,2.14,4.39,0.05,6.61c-0.37,0.03-0.74,0-1.1-0.08
		C20.87,421.29,20.87,419.14,20.87,416.99z"
            />
            <path
              class="flower_type_3_color1"
              @click.stop="clickHandle(3, 1)"
              d="M22,404.16c0-2.19,0-4.38-0.01-6.58c3.58-14,10.36-26.75,15.83-39.99c19.05-46.17,38.44-92.19,57.8-138.23
		c15.95-37.94,30.67-76.47,48.38-113.57c21.85-45.76,59.86-72.57,109.67-80.2c46.72-7.15,88.2,6.32,123.12,38.71
		c0.78,0.73,1.63,1.39,2.45,2.08c0.49,1.12,0.06,2.08-0.55,2.99c-0.84,1.26-1.94,2.29-2.99,3.36
		C263.08,187.75,148.48,300.8,34.87,414.82c-1.5,1.51-2.88,3.22-5.02,3.92c-5.78-1.22-6.39-6.09-7.48-10.62
		C22.25,406.8,22.12,405.48,22,404.16z"
            />
            <path
              class="flower_type_3_color2"
              @click.stop="clickHandle(3, 2)"
              d="M385.77,74.04c12.52,12.43,20.66,27.63,27.16,43.76c8.86,21.99,11.35,45.01,10.05,68.54
		c-0.73,3.81-0.67,7.69-1.13,11.53c-3.9,27.66-16.41,51.24-34.41,72.14c-17.68,20.53-40.36,33.65-65.16,43.72
		c-64.26,26.1-128.2,52.98-192.37,79.29c-24.04,9.86-47.98,19.96-72.05,29.71c-6.28,2.54-12.82,5.57-19.75,1.54
		c-1.3-1.09-0.79-2.29-0.13-3.43c0.87-1.5,2.15-2.66,3.35-3.89C152.81,302.92,266.45,191.03,378.99,78.06
		C380.84,76.2,382.3,73.32,385.77,74.04z"
            />
            <path
              class="st418"
              d="M37.66,423.43c9.93,3.15,18.39-1.65,26.99-5.17c33.25-13.64,66.46-27.41,99.66-41.16
		c39.53-16.37,79.05-32.78,118.57-49.17c18.97-7.87,38.31-14.89,56.78-23.93c40.89-20.03,66.67-52.58,79-96.11
		c0.92-3.26,1.29-6.69,1.92-10.04c3.47,1.59,1.61,4.3,1.38,6.66c-1.94,28.99-12.92,54.42-30.52,77.2
		c-18.71,24.22-43.89,38.99-71.81,50.4c-88.18,36.02-176.12,72.62-264.19,108.92c-15.45,6.37-29.59-1.15-33.47-17.51
		c-0.02-2.2-0.03-4.4-0.04-6.61c0.15-2.93,0.29-5.86,0.44-8.79c2.31,3.53,3.43,7.95,7.52,10.17c1.43,0.15,2.36,1.16,3.4,1.97
		C34.61,421.51,36.5,421.96,37.66,423.43z"
            />
            <path
              class="st469"
              d="M37.66,423.43c-2.22,0.14-4.2-0.21-5.18-2.57c0.54-2.76,2.77-4.28,4.57-6.06
		c84.15-83.23,166.56-168.19,250.39-251.73c29.52-29.42,58.93-58.95,88.46-88.35c1.99-1.98,3.48-5.16,7.22-4.48
		c1.31,0.97,2.21,2.22,2.64,3.8c-1.77,1.54-3.64,2.98-5.29,4.63c-99.3,99.29-198.76,198.43-297.69,298.09
		C67.56,392.1,51.93,407.13,37.66,423.43z"
            />
            <path
              class="st419"
              d="M383.12,70.24c-1.77,1.54-3.63,2.99-5.28,4.65c-61.49,61.5-123.39,122.6-184.3,184.68
		C142.12,311.98,89.82,363.51,38.21,415.73c-1.8,1.82-3.81,3.42-5.73,5.12c-0.86-0.85-1.73-1.71-2.59-2.56
		c1.71-1.91,3.33-3.91,5.14-5.72c97.92-97.97,196.05-195.73,293.59-294.07c17.04-17.18,34.52-34,50.62-52.12
		C381.13,67.06,382.4,68.38,383.12,70.24z"
            />
            <path
              class="st468"
              d="M421.96,204.5c-0.57-2.2,0.79-4.8-1.39-6.66c0.71-3.85,0.75-7.85,2.39-11.51
		C422.91,192.4,424.07,198.54,421.96,204.5z"
            />
          </g>
        </svg>
      </template>
      <template v-if="len === 3">
        <svg
          class="flower_type_3 flower_type"
          data-name="图层 2"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 441.96 461.55"
        >
          <g id="_图层_1-2" data-name="图层 1">
            <g>
              <path
                class="flower_type_3_color1"
                @click.stop="clickHandle(3, 3)"
                d="M.67,423.04c-1.34-8.99.65-17.29,4.17-25.63,29.96-71.17,59.7-142.43,89.52-213.66.5-1.19,1.13-2.32,1.69-3.47,2.03-1.66,4.12-.63,6.12-.02,39.03,11.96,77.94,24.31,116.97,36.26,6.59,2.02,9.57,5.84,11.32,12.34,10.06,37.36,20.1,74.73,30.4,112.02.51,1.86,1.23,3.69.73,5.67-8.43,5.77-18.31,8.36-27.59,12.18-65.82,27.12-131.48,54.64-197.4,81.51-9.86,4.02-18.96,2.87-27.41-3.37-4.62-3.42-7.91-7.85-8.53-13.83Z"
              />
              <path
                :class="`flower_type_3_color2`"
                @click.stop="clickHandle(3, 1)"
                d="M98.71,173.85c13.41-31.08,23.84-63.57,40.68-93.03C163.26,39.07,199.55,13.1,246.63,3.57c51.73-10.47,98.06,2.24,138.68,35.83,2.79,2.31,5.16,5.14,7.73,7.72.75,2.91-1.57,4.28-3.15,5.86-52.23,52.31-104.5,104.58-156.79,156.83-1.82,1.82-3.66,3.68-6.46,3.98-10.43-1.67-20.2-5.67-30.26-8.65-30.02-8.9-59.97-18.05-89.92-27.18-2.8-.85-5.96-1.28-7.77-4.12Z"
              />
              <path
                :class="`flower_type_3_color3`"
                @click.stop="clickHandle(3, 2)"
                d="M396.9,50.97c18.74,19,31.12,41.63,38.56,67.14,5.94,20.37,6.98,41.2,6.25,62.22-1.19,2.57-1.17,5.3-1.13,8.04-1.59,17.86-7.63,34.35-15.88,50.05-15.85,30.16-38.93,53.23-69.08,69.18-15.62,8.27-32.37,13.91-48.54,20.91-10.45,4.52-21,8.83-31.62,12.98-6.74,2.64-8.07,2.2-10.01-4.9-3.4-12.44-7-24.83-10.32-37.29-6.42-24.1-13.15-48.11-19.84-72.12-1.98-7.09-.58-12.03,4.67-17.24,50.02-49.71,99.84-99.62,149.64-149.55,2.22-2.22,6.11-3.94,4.18-8.37.63-1.55,1.7-1.81,3.11-1.06Z"
              />
              <path
                class="cls-5"
                d="M394.17,52.51c1.98.33,4.42.46,2.2,3.39-1.03,1.36-2.39,2.47-3.61,3.68-50.75,50.77-101.46,101.58-152.34,152.22-4.12,4.1-5.55,7.66-3.91,13.51,10.42,37.06,20.53,74.22,30.53,111.4,1.39,5.16,3.1,5.43,7.84,3.39,24.99-10.74,50.81-19.75,75.18-31.71,48.9-24,78.39-63.68,89.11-117.17.21-1.04.09-2.14.13-3.22,3.6,2.59,1.63,6.03,1.39,9.2-2.2,33.47-14.77,62.79-35.54,88.84-21.06,26.42-49.33,41.85-80.03,54.39-95.81,39.13-191.44,78.73-286.94,118.61-20.55,8.58-40.69-6.08-37.93-26.35.43-3.18.29-6.44.41-9.66,8.63,17.04,20.23,21.63,37.97,14.36,53.75-22.02,107.42-44.24,161.13-66.36,19.22-7.92,38.46-15.81,57.71-23.67,1.16-.47,2.5-.5,3.76-.74,1.54-4.61-.11-8.91-1.3-13.24-9.79-35.64-19.27-71.37-29.36-106.92-2.1-7.41-.47-11.98,5-17.4,50.57-50.05,100.76-100.47,151.1-150.75,2.23-2.23,4.04-5.12,7.5-5.81Z"
              />
              <path
                class="cls-3"
                d="M394.17,52.51c-.83.98-1.6,2.02-2.5,2.93-53.04,53-106.07,106.01-159.23,158.89-2.36,2.35-2.09,4.13-1.37,6.77,10.16,37.18,20.23,74.39,30.32,111.58.73,2.69,1.62,5.34,2.2,8.05.51,2.39.59,4.8-2.36,5.9-6.15-16.04-9.4-32.92-14.06-49.38-6.81-24.1-13.16-48.33-19.6-72.53-.76-2.84-2.34-4.28-5.06-5.13-30.9-9.62-61.78-19.33-92.68-28.97-11.25-3.51-22.53-6.89-33.8-10.33.47-1.34.94-2.68,1.4-4.02,8.15-.33,15.34,3.5,22.79,5.78,32.98,10.08,65.94,20.24,98.91,30.34,2.8.86,5.63,2.5,8.5.13,1.46-1.25,3.01-2.4,4.37-3.75,52.44-52.4,104.86-104.82,157.27-157.26,1.36-1.36,2.51-2.91,3.76-4.37,2.18.39,3.43,1.7,3.85,3.84-1.1.18-2.19.36-2.73,1.54Z"
              />
              <path
                class="cls-1"
                d="M227.65,212.51c-1.36,3.45-3.81,3.3-6.83,2.35-25.37-7.97-50.76-15.84-76.14-23.77-15.75-4.92-31.48-9.89-47.23-14.83.42-.8.84-1.61,1.26-2.41,36.4,11.07,72.79,22.17,109.2,33.2,6.53,1.98,13.15,3.65,19.73,5.46Z"
              />
              <path
                class="cls-2"
                d="M440.7,197.21c-.81-3.01,1.13-6.44-1.39-9.2-.16-2.86.08-5.6,2.4-7.68-.13,5.64,1.14,11.36-1.01,16.88Z"
              />
            </g>
          </g>
        </svg>
      </template>
    </template>

    <!-- 第四种类型 -->
    <template v-if="index === 4">
      <template v-if="len === 1">
        <svg
          version="1.1"
          class="flower_type_4 flower_type"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <g>
            <path
              class="st445"
              @click.stop="clickHandle(4, 1)"
              d="M330.34,86.3c1.91,0,3.82,0,5.73,0c4.62,1.09,9.38,0.88,14.06,1.41c20.14,2.28,37.52,11.17,53.22,23.24
		c29.77,22.88,47.32,53.01,52.16,90.47c1.11,8.58,0.95,17.08,0.77,25.64c-0.28,2.06-0.96,4.04-1.23,6.1
		c-0.58,2.61-0.48,5.35-1.33,7.91c-4.07,25.09-14.43,47.04-31.7,65.89c-19.13,20.87-42.15,34.81-69.79,40.93
		c-23.36,5.17-46.55,4.3-69.35-3.11c-21.96-7.14-42.77-17.17-64.12-25.83c-30.37-12.33-60.54-25.12-90.81-37.69
		c-33.61-13.95-67.21-27.94-100.84-41.85c-7.87-3.25-13.01-8.39-14.4-16.92c-0.07-0.57-0.11-1.14-0.11-1.71
		c-0.19-17.58,2.16-21.12,18.49-27.86c46.11-19.04,92.3-37.89,138.47-56.79c34.89-14.28,69.79-28.54,104.6-43.03
		c10.61-4.42,21.68-5.43,32.89-6.22c0.93-0.07,1.91,0.16,2.7-0.58c1.91,0,3.82,0,5.73,0C320.42,87.22,325.38,87.22,330.34,86.3z"
            />
            <path
              class="st450"
              d="M330.34,86.3c-4.96,1.82-9.92,1.82-14.89,0C320.42,86.3,325.38,86.3,330.34,86.3z"
            />
            <path
              class="st446"
              d="M452.98,247c-1.97,28.68-13.36,53.42-32.31,74.61c-37.68,42.14-96.09,55.33-148.31,33.7
		c-81.29-33.66-162.52-67.48-243.77-101.24c-10.88-4.52-15.38-11.21-15.43-22.86c-0.01-2.86,0.11-5.71,0.17-8.57
		c4.32,11.04,14.48,14.35,24.17,18.35c38.56,15.93,77.11,31.9,115.64,47.89c40.11,16.66,80.04,33.77,120.36,49.93
		c33.03,13.24,66.47,13.45,99.63-0.26c29.13-12.05,50.81-32.44,65.8-59.91c6.41-11.74,10.8-24.36,12.86-37.68
		C454.89,242.45,453.13,244.88,452.98,247z"
            />
            <path
              class="st451"
              d="M452.98,247c-0.32-2.03,0.28-4.24-1.18-6.04c0.36-2.69,0.72-5.39,1.08-8.08c0.32-0.81,0.64-0.81,0.96,0
		C453.96,237.61,454.47,242.37,452.98,247z"
            />
            <path
              class="st452"
              d="M453.84,232.88l-0.48-0.01c0,0-0.48,0-0.48,0.01c0.05-1.93-0.34-3.92,0.92-5.65
		C453.81,229.11,453.82,231,453.84,232.88z"
            />
          </g>
        </svg>
      </template>
      <template v-if="len === 2">
        <svg
          version="1.1"
          class="flower_type_4 flower_type"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <g xmlns="http://www.w3.org/2000/svg">
            <path
              class="flower_type_4_color1"
              @click.stop="clickHandle(4, 1)"
              d="M11.57,211.78c0.6-9.32,5.65-15.23,14.1-18.69c38.99-15.96,77.95-31.98,116.92-47.96   c41.77-17.13,83.36-34.73,125.38-51.22c53.45-20.97,101.85-11.63,143.41,27.88c21.14,20.1,33.19,45.56,36.88,74.76   c0.64,5.09,1.21,10.11,0.83,15.22c-1.99,1.98-4.54,1.63-6.98,1.63c-141.19,0.02-282.39,0.02-423.58,0   C16.12,213.4,13.56,213.76,11.57,211.78z"
            />
            <path
              class="flower_type_4_color2"
              @click.stop="clickHandle(4, 2)"
              d="M449.16,218.63c-0.02,1.14-0.05,2.28-0.07,3.41c-0.81,2.25-0.2,4.59-0.4,6.88   c0.26,15.79-4.88,30.31-12.03,43.88c-18.82,35.68-47.77,59.11-87.25,68.75c-27.98,6.84-55.32,3.88-81.8-6.99   c-51.49-21.15-102.86-42.62-154.27-63.96c-29.21-12.13-58.43-24.2-87.64-36.33c-4.83-2.01-9.27-4.61-11.86-9.25   c-1.3-2.34-3.74-5.31,0.31-7.72c2.43-0.72,4.91-0.45,7.36-0.45c139.48-0.01,278.96-0.02,418.44,0.02   C443.09,216.87,446.48,216.07,449.16,218.63z"
            />
            <path
              class="st446"
              d="M12.44,218.67c1.94,6.88,6.49,11.13,13.04,13.84c51.47,21.26,102.91,42.59,154.33,63.96   c30.51,12.68,60.72,26.11,91.53,38.01c32.78,12.66,65.86,12.5,98.68-1.22c15.43-6.45,29.13-15.51,40.68-27.19   c21.11-21.37,34.49-46.92,37.47-77.28c0.32-0.53,0.63-0.53,0.94,0c2.39,49.28-29.5,99.61-76.23,120.23   c-36.13,15.94-72.17,14.89-108.34-0.19c-78.45-32.71-156.98-65.2-235.48-97.78c-15.69-6.51-18.26-11.26-17.56-32.38   C11.82,218.19,12.13,218.22,12.44,218.67z"
            />
            <path
              class="st447"
              d="M11.57,211.78c115.92-0.02,231.84-0.04,347.75-0.06c29.93,0,59.85,0.03,89.78,0.05   c0.02,1.08,0.04,2.15,0.06,3.23c-2.67,2.58-6.05,1.79-9.19,1.79c-110.22,0.03-220.44,0.03-330.66,0.03   c-29.92,0-59.84,0.01-89.77-0.02c-2.8,0-5.75,0.51-8.05-1.8C11.52,213.93,11.55,212.85,11.57,211.78z"
            />
            <path
              class="st448"
              d="M11.5,215c1.51,0.04,3.03,0.12,4.54,0.12c142.86,0.01,285.72,0.01,428.58,0c1.51,0,3.03-0.08,4.54-0.12   c0,1.21,0,2.42-0.01,3.63c-14.41-0.03-28.81-0.09-43.22-0.09c-128.71-0.01-257.41,0-386.12,0c-2.46,0-4.93,0.08-7.39,0.13   c0,0-0.47-0.06-0.47-0.06s-0.47,0.06-0.47,0.06C11.5,217.44,11.5,216.22,11.5,215z"
            />
            <path
              class="st449"
              d="M449.11,228.79c0,0-0.47-0.01-0.47-0.01s-0.47,0.01-0.47,0.01c0.28-2.25-0.82-4.69,0.92-6.74   C449.1,224.29,449.1,226.54,449.11,228.79z"
            />
          </g>
        </svg>
      </template>
      <template v-if="len === 3">
        <svg
          version="1.1"
          class="flower_type_4 flower_type"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <g>
            <path
              class="flower_type_4_color1"
              @click.stop="clickHandle(4, 3)"
              d="M14.61,201.93c4.66-10.1,13.94-13.8,23.52-17.67c56.09-22.7,112.06-45.69,168.07-68.58
            c0.86-0.35,1.78-0.59,2.67-0.87c1.87,0.51,2.56,2.13,3.34,3.61c15.08,28.65,30.65,57.03,45.95,85.57c2.72,5.07,2.74,9.27-0.2,14.17
            c-15.88,26.49-30.77,53.55-46.49,80.12c-0.95,1.6-1.65,3.45-3.82,3.87c-12.05-3.39-23.22-9.03-34.74-13.76
            c-37.25-15.31-74.44-30.78-111.67-46.15c-10.66-4.4-21.27-8.93-31.98-13.21c-7.44-2.97-12.98-7.56-14.64-15.79
            C14.61,209.47,14.61,205.7,14.61,201.93z"
            />
            <path
              class="st446"
              d="M14.61,213.24c5.91,14.01,19.94,16.23,31.79,21.23c37.52,15.83,75.23,31.22,112.86,46.8
            c16.2,6.71,32.38,13.46,48.58,20.19c4.13,0.16,4.51-3.63,5.88-5.97c13.86-23.79,27.54-47.67,41.34-71.49
            c8.62-14.88,5.11-13.51,23.11-13.52c54.49-0.03,108.98-0.02,163.47,0.01c2.99,0,6.08-0.51,8.9,1.03c1.82,3.29,0.45,4.88-2.92,5.34
            c-2.26,0.31-4.53,0.2-6.8,0.2c-55.04,0.01-110.08,0.11-165.12-0.14c-6.55-0.03-10.33,2.1-13.5,7.74
            c-13.67,24.32-27.44,48.59-41.43,72.73c-3.18,5.48-2.89,6.43,2.92,8.72c20.04,7.9,39.31,17.8,60.01,23.91
            c46.25,13.66,87.83,4.72,124.19-27.04c19.95-17.42,32.53-39.35,39.06-64.87c0.63-2.47,0.58-5.34,3.11-7.02
            c2.48,1.76,1.16,4.04,0.87,6.19c-1.43,24.66-10.46,46.62-25.48,65.87c-27.22,34.86-63.46,51.93-107.8,51.23
            c-18.56-0.29-36-5.76-53.07-12.86c-78.09-32.45-156.25-64.74-234.45-96.93c-7.97-3.28-12.9-8.75-15.51-16.66
            C14.61,223.04,14.61,218.14,14.61,213.24z"
            />
            <path
              class="flower_type_4_color2"
              @click.stop="clickHandle(4, 1)"
              d="M214.51,112.65c26.97-10.77,52.82-24.62,81.4-30.99c69.88-15.58,141.6,32.54,153.8,102.82
            c1.38,7.98,2.62,15.98,2.11,24.13c-1.77,1.81-4.06,1.79-6.35,1.79c-58.08,0-116.15,0.04-174.23-0.02c-0.76,0-1.51-0.06-2.24-0.2
            c-2.95-0.51-4.32-2.74-5.62-5.1c-16.09-29.02-31.95-58.17-47.85-87.29C214.68,116.23,213.05,114.71,214.51,112.65z"
            />
            <path
              class="flower_type_4_color3"
              @click.stop="clickHandle(4, 2)"
              d="M449.74,231.38c-2.59,15.76-8.1,30.48-16.62,43.96c-19.46,30.81-46.7,51-82.56,59.18
            c-21.95,5.01-43.71,4.35-65.24-2.27c-22.75-6.99-43.98-17.83-66.19-26.19c-3.64-1.37-3.27-3.18-1.68-5.96
            c10.39-18.11,20.66-36.28,31.02-54.41c4.85-8.49,10.15-16.75,14.59-25.44c2.14-4.18,4.87-4.83,9-4.83
            c57.51,0.1,115.02,0.09,172.52-0.01c2.29,0,6.25,1.94,6.15-3.17c0.34-0.46,0.7-0.45,1.07-0.04c-0.02,1.88-0.04,3.76-0.05,5.64
            c-0.77,1.95-0.22,3.98-0.39,5.97C451.27,226.44,451.89,229.21,449.74,231.38z"
            />
            <path
              class="st447"
              d="M451.81,212.22l-0.54-0.04c0,0-0.53,0.07-0.53,0.07c-45.77-0.05-91.53-0.1-137.3-0.14
            c-12.29-0.01-24.66,0.8-36.86-0.25c-9.95-0.85-14.95,2.78-19.59,11.33c-14.01,25.81-29.07,51.06-43.74,76.51
            c-1.23,2.14-2.14,5.63-5.41,1.77c12.44-21.45,24.88-42.91,37.33-64.36c4.15-7.15,8.2-14.37,12.5-21.43
            c1.97-3.23,1.96-5.91,0.12-9.3c-15.4-28.45-30.63-56.99-45.89-85.51c-1.07-1.99-2.02-4.04-3.03-6.06c0.71-1.28,1.97-1.18,3.16-1.22
            c2.55,1.58,3.59,4.24,4.91,6.72c14.89,27.92,30.18,55.62,45.01,83.57c1.09,2.06,2.49,3.76,4.71,4.69
            c40.77,0.05,81.54,0.12,122.31,0.15c20.95,0.01,41.9-0.06,62.85-0.1C451.82,209.81,451.81,211.01,451.81,212.22z"
            />
            <path
              class="st448"
              d="M266.67,208.56c-2.64,0.65-4.13-0.48-5.37-2.82c-16.37-30.74-32.82-61.44-49.26-92.15
            c0.82-0.31,1.65-0.62,2.47-0.94c11.27,20.77,22.53,41.54,33.82,62.3C254.42,186.17,260.55,197.36,266.67,208.56z"
            />
            <path
              class="st449"
              d="M449.74,231.38c0.52-2.63,1.43-5.2,1.09-7.95c0.33-0.54,0.65-0.51,0.96,0.01c0.05,4.64,0.76,9.31-0.86,13.85
            C450.44,235.34,451.6,233.06,449.74,231.38z"
            />
            <path
              class="st450"
              d="M451.79,223.45l-0.48-0.02c0,0-0.48,0-0.48,0c0.23-1.87-0.68-3.93,0.93-5.58
            C451.77,219.72,451.78,221.58,451.79,223.45z"
            />
          </g>
        </svg>
      </template>
    </template>

    <!-- 第五种类型 -->
    <template v-if="index === 5">
      <template v-if="len === 1">
        <svg
          version="1.1"
          class="flower_type_5 flower_type"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <g>
            <path
              class="st423"
              @click.stop="clickHandle(5, 1)"
              d="M27.59,50.22c0.85-2.54,0.37-4.97-0.22-7.52c-2.14-9.24,0.37-17.22,7.5-23.38
		c7.39-6.39,16.02-7.4,24.91-3.74c24.75,10.18,49.41,20.6,74.1,30.94c68.1,28.51,136.22,56.96,204.27,85.57
		c56.58,23.78,91.79,76.98,91.84,138.4c0,4.97-0.11,9.94-0.16,14.91c-0.61,3.11-1.06,6.24-1.1,9.43
		c-1.18,15.14-6.18,29.25-13.2,42.42c-23.29,43.7-59,71.65-108.09,79.97c-49.58,8.41-93.19-4.8-130.12-39.74
		c-18.26-17.28-30.02-38.34-39.34-61.15c-29.37-71.91-59.28-143.58-88.86-215.4C42.13,83.95,35.78,66.69,27.59,50.22z"
            />
            <path
              class="st424"
              d="M27.59,50.22c2.63-1.43,2.84,0.92,3.42,2.33c11.22,27.08,22.4,54.18,33.57,81.28
		c16.19,39.26,32.13,78.62,48.63,117.75c12.31,29.2,22.43,59.41,37.32,87.42c21.82,41.04,55.94,66.86,101.59,76.03
		c41.51,8.33,80.26,0.24,114.92-24.27c32.55-23.02,52.54-54.55,60.33-93.71c0.17-0.84,0.06-1.73,0.08-2.59
		c3.84,2.14,1.32,5.39,1.45,8.18c-3.47,41.48-21.97,75.27-53.96,101.21c-74.67,60.56-184.71,36.4-226.69-50.09
		c-18.29-37.67-32.52-77.19-48.59-115.87C76.13,181.26,52.83,124.53,29.37,67.86C26.99,62.1,25.63,56.36,27.59,50.22z"
            />
            <path
              class="st464"
              d="M428.9,302.65c-0.84-2.66,0.95-5.79-1.45-8.18c0.17-3.18,0.95-6.21,2.37-9.06
		C429.97,291.17,430.67,296.97,428.9,302.65z"
            />
          </g>
        </svg>
      </template>
      <template v-if="len === 2">
        <svg
          version="1.1"
          class="flower_type_5 flower_type"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <g>
            <path
              class="flower_type_5_color1"
              @click.stop="clickHandle(5, 1)"
              d="M36.5,24.45c9.45-6.5,19-6.2,29.43-1.81c93.41,39.3,186.95,78.3,280.4,117.52
		c58.03,24.36,93.98,78.62,94.03,141.47c0,5.08-0.11,10.17-0.17,15.25c-0.62,3.14-1.03,6.31-1.13,9.52
		c-1,14.5-6.1,27.84-12.17,40.75c-6.97,14.81-16.62,27.9-27.7,39.93c-0.9,0.98-1.96,1.76-3.31,2.05c-0.68,0.07-1.33-0.05-1.94-0.37
		c-0.72-0.79-0.86-1.72-0.63-2.74c1.02-1.57,1.58-3.08-0.07-4.7c-1.42-1.39-2.79-2.83-4.2-4.24
		C274.47,262.51,159.88,147.94,45.35,33.31C42.4,30.36,38.91,27.94,36.5,24.45z"
            />
            <path
              class="flower_type_5_color2"
              @click.stop="clickHandle(5, 2)"
              d="M393.96,388.4c0.44,0,0.88,0,1.31,0c0.71,2.43-1.05,3.65-2.5,4.95c-28.92,26.05-62.67,39.97-101.75,40.6
		c-36.31,0.58-68.85-10.12-97.31-32.68c-21.38-16.96-37.3-38.16-47.75-63.43c-28.48-68.86-56.91-137.73-85.34-206.61
		c-9.45-22.89-18.72-45.86-28.5-68.6c-2.3-5.34-3.66-10.83-4.21-16.57c0.11-5.61,1.01-11.01,4.03-15.88
		c4.21-0.19,5.98,3.36,8.36,5.73c92.12,92.02,184.18,184.1,276.25,276.18c23.13,23.14,46.27,46.27,69.4,69.41
		C388.45,384,390.91,386.53,393.96,388.4z"
            />
            <path
              class="st424"
              d="M27.91,46.06c10.8,29.58,23.68,58.3,35.56,87.44c18.13,44.47,36.39,88.9,54.78,133.26
		c10.97,26.46,21.31,53.24,33.67,79.05c22.59,47.18,60.52,75.94,111.98,84.52c42.97,7.16,82.7-2.66,117.46-29.93
		c4.83-3.79,9.85-7.33,13.91-12c22.65-23.04,37.78-49.96,42.49-82.26c3.92,2.18,1.35,5.51,1.48,8.36
		c-3.55,42.38-22.45,76.91-55.14,103.42c-76.29,61.88-188.73,37.19-231.65-51.15c-18.41-37.89-32.71-77.66-48.92-116.55
		C80.02,193.8,57.03,137.16,33.36,80.81C28.58,69.43,26.68,58.12,27.91,46.06z"
            />
            <path
              class="st425"
              d="M393.96,388.4c-3.89,1.89-5.03-1.87-6.79-3.63c-69.15-69.01-138.22-138.11-207.3-207.19
		C132.52,130.23,85.16,82.87,37.79,35.53c-1.87-1.87-3.9-3.57-5.85-5.35c0.33-2.38,1.95-3.83,3.69-5.21
		c3.24,2.36,5.83,5.4,8.64,8.21c114.56,114.54,229.11,229.08,343.6,343.69c2.51,2.51,6.35,4.33,6.16,8.82
		C394,386.59,393.98,387.49,393.96,388.4z"
            />
            <path
              class="st428"
              d="M394.03,385.68c-1.8-1.94-3.54-3.94-5.41-5.81C272.59,263.82,156.56,147.79,40.56,31.72
		c-1.96-1.96-4.79-3.41-4.92-6.75c0.19-0.33,0.48-0.51,0.87-0.52c2.94,0.27,4.58,2.48,6.44,4.34
		c116.84,116.84,233.69,233.68,350.42,350.64C394.6,380.67,401.54,382.89,394.03,385.68z"
            />
            <path
              class="st464"
              d="M439.25,314.5c-0.86-2.72,0.97-5.92-1.48-8.36c0.17-3.25,0.97-6.34,2.42-9.26
		C440.34,302.77,441.06,308.7,439.25,314.5z"
            />
          </g>
        </svg>
      </template>
      <template v-if="len === 3">
        <svg
          version="1.1"
          class="flower_type_5 flower_type"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <g>
            <path
              class="st422"
              d="M48.3,12.65c0,0.38,0.01,0.76,0.04,1.14c-2.26,2.13-4.52,2.13-6.79,0.01c0.03-0.38,0.04-0.77,0.04-1.15
          C43.82,12.65,46.06,12.65,48.3,12.65z"
            />
            <path
              class="flower_type_5_color1"
              @click.stop="clickHandle(5, 3)"
              d="M41.55,13.8c2.26,0,4.53-0.01,6.79-0.01c17.93,5.61,34.83,13.76,52.14,20.87
          C156.59,57.72,212.6,81,268.65,104.2c1.31,2.21,0.27,4.33-0.36,6.41c-10.92,35.89-22.42,71.61-33.31,107.51
          c-2.04,6.73-5.81,10.07-12.69,11.86c-34.65,8.99-69.26,18.17-103.82,27.5c-2.58,0.7-5.14,1.63-7.9,1.05
          c-3.05-1.31-3.7-4.3-4.79-6.91C78.52,186.47,51.56,121.2,24.12,56.12c-2.1-4.98-3.12-10.11-3.75-15.39
          C21.37,24.83,27.04,17.62,41.55,13.8z"
            />
            <path
              class="flower_type_5_color2"
              @click.stop="clickHandle(5, 1)"
              d="M275.28,107.46c26.31,10.51,53.2,19.91,78.28,32.99c54.64,28.48,82.3,74.28,84.3,135.36
          c0.18,5.54-0.09,11.08-0.15,16.63c-0.74,2.18-0.75,4.36,0.01,6.54c0.19,4.12,0.59,8.26-1,12.24c-2.78-3.04,0.06-6.17-0.38-8.05
          c-3.73,31.38-19.45,58.08-41.94,81.38c-17.53-18.49-35.95-36.11-54.01-54.08c-32-31.83-64.1-63.56-96.13-95.37
          c-2.64-2.62-5.9-4.88-6.5-9c1.62-10.35,5.53-20.08,8.49-30.05c7.95-26.8,16.16-53.52,24.28-80.27
          C271.45,112.73,271.62,109.06,275.28,107.46z"
            />
            <path
              class="st424"
              d="M393.58,384.25c3.67-6.89,9.97-11.68,14.5-17.92c14.11-19.46,23.54-40.83,28.64-64.48c0,3.12,0,6.24,0,9.37
          c-3.92,41.71-22.74,75.83-55.08,102.17c-76.98,62.69-191.7,38.13-235.13-50.73c-19.38-39.65-34.5-81.22-51.56-121.92
          C71.88,185.71,49.2,130.53,25.89,75.61c-4.85-11.42-6.77-22.78-5.52-34.89C31.2,70.2,44.15,98.82,56.1,127.84
          c17.86,43.39,36.04,86.64,54.08,129.96c1.11,1.08,2.12,2.22,2.59,3.74c0.68,2.08,1.73,3.96,2.98,5.76
          c9.59,21.26,17.75,43.12,27.22,64.42c24.62,55.34,66.91,88.12,127.84,94.28c39.02,3.95,74.93-6.62,106.22-30.85
          c2.64-2.05,5.21-4.19,7.91-6.17c1.88-1.15,3.58-2.53,5.23-3.99C391.2,384.31,392.22,383.51,393.58,384.25z"
            />
            <path
              class="st425"
              d="M393.58,384.25c-0.88,0.42-1.75,0.84-2.63,1.26c-2.7-0.32-4.22-2.39-5.93-4.08
          c-49.14-48.85-98.65-97.34-147.44-146.54c-2.75-2.78-5.34-3.37-8.97-2.36c-35.77,9.92-71.75,19.02-107.57,28.78
          c-3.09,0.84-6.29,2.83-9.6,0.44c-0.42-1.31-0.84-2.63-1.26-3.94c38.04-10.16,76.05-20.45,114.17-30.33
          c4.59-1.19,6.71-3.19,8.02-7.44c11.55-37.39,23.26-74.73,34.92-112.09c0.4-1.27,0.9-2.5,1.36-3.75c2.37-1.32,3.9-0.05,5.3,1.66
          c-12.08,37.79-23.41,75.82-35.17,113.71c-0.78,2.52-1.87,5.11,0.31,7.53c1.77,1.98,3.44,4.06,5.32,5.92
          c48.07,47.7,96.17,95.37,144.23,143.08C390.93,378.38,394.19,380.2,393.58,384.25z"
            />
            <path
              class="st426"
              d="M239.09,227.1c-3.56-1.4-3.45-3.89-2.47-7.02c9.29-29.5,18.49-59.03,27.71-88.55
          c2.11-6.75,4.13-13.53,6.31-20.25c0.65-2.02,0.71-4.52,3.31-5.42c0.44,0.53,0.89,1.06,1.33,1.59
          c-6.67,21.49-13.39,42.96-19.99,64.46c-4.85,15.81-9.58,31.67-14.31,47.52C240.23,221.95,239.71,224.54,239.09,227.1z"
            />
            <path
              class="st427"
              d="M437.72,298.97c-1.7-2.18-1.68-4.36-0.01-6.54C437.72,294.61,437.72,296.79,437.72,298.97z"
            />
            <path
              class="flower_type_5_color3"
              @click.stop="clickHandle(5, 2)"
              d="M386.91,389.59c-22.14,19.22-47.56,31.79-76.65,36.59c-36.23,5.98-70.59,0.24-102.51-17.86
          c-36.88-20.91-59.02-53.48-73.44-92.19c-6.17-16.56-13.41-32.74-20.17-49.09c0.89-2.55,3.28-2.79,5.39-3.37
          c34.7-9.45,69.39-18.91,104.02-28.61c7.62-2.14,12.91-0.6,18.48,5c30.76,30.93,62.26,61.15,92.68,92.4
          c16.29,16.74,32.88,33.18,49.2,49.89C385.77,384.27,388.83,386,386.91,389.59z"
            />
            <path
              class="st428"
              d="M386.91,389.59c0.04-2.56-1.93-3.88-3.47-5.43c-28.38-28.58-56.72-57.19-85.18-85.69
          c-19.51-19.54-39.31-38.8-58.72-58.43c-4.07-4.12-7.66-5.46-13.5-3.81c-37.24,10.49-74.59,20.59-111.91,30.82
          c-1.75-1.35-2.47-3.21-2.69-5.32c21.98-5.72,43.97-11.38,65.93-17.19c17.66-4.67,35.28-9.54,52.92-14.3
          c2.42-0.65,4.69-0.98,6.79,1.19c49.76,51.32,101.33,100.86,151.8,151.48c0.78,0.78,1.39,1.72,2.07,2.58
          C390.09,387.34,388.73,388.69,386.91,389.59z"
            />
          </g>
        </svg>
      </template>
    </template>

    <!-- 第六种类型 -->
    <template v-if="index === 6">
      <template v-if="len === 1">
        <svg
          version="1.1"
          class="flower_type_6 flower_type"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <!-- <rect x="60.81" y="-118.64" class="st4" width="390" height="248" /> -->
          <g>
            <path
              class="st436"
              @click.stop="clickHandle(6, 1)"
              d="M98.06,324.18c-2.05-27.12,5.54-52.05,15.96-76.75c30.82-73.04,60.93-146.39,91.32-219.61
		c3.9-9.41,11.34-15.1,20.03-14.49c9.32,0.66,15.36,5.93,18.89,14.58c32.29,78.99,64.71,157.92,96.99,236.91
		c7.77,19.02,10.17,38.94,9.02,59.36c-0.47,3.29-0.89,6.59-0.94,9.93c-3,22.73-12.99,42.31-27.51,59.65
		c-22.42,26.8-51.42,41.98-86.01,45c-36,3.15-68.21-7.1-95.7-31.18c-19.2-16.82-32.11-37.49-38.95-62
		c-1.13-4.03-2.15-8.14-2.16-12.39C98.84,330.18,98.6,327.17,98.06,324.18z"
            />
            <path
              class="st437"
              d="M100.07,332.96c2.15,16.03,7.94,30.72,16.39,44.42c17.62,28.56,42.62,47.74,74.96,56.16
		c38.85,10.11,75.34,3.5,107.78-20.41c26.68-19.66,43.19-46.22,49.06-79.09c2.97,1.37,1.37,3.69,1.18,5.71
		c-1.85,27.18-12.35,50.85-30.2,71.06c-27.05,30.63-61.45,44.83-102.22,43.29c-56.44-2.13-107.51-47.16-116.91-102.86
		c-0.64-3.79-1.48-7.56-1.24-11.45C98.94,337.45,96.83,334.74,100.07,332.96z"
            />
            <path
              class="st440"
              d="M349.45,339.76c-0.51-1.88,0.67-4.11-1.18-5.71c-0.14-3.45,0.92-6.66,2.01-9.85
		C350.34,329.4,351.15,334.64,349.45,339.76z"
            />
            <path
              class="st463"
              d="M100.07,332.96c-2.02,1.99-0.55,4.59-1.2,6.83c-1.7-5.13-0.86-10.39-0.81-15.61
		C99.41,326.95,99.62,329.98,100.07,332.96z"
            />
          </g>
        </svg>
      </template>
      <template v-if="len === 2">
        <svg
          version="1.1"
          class="flower_type_6 flower_type"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <g>
            <path
              class="flower_type_6_color1"
              @click.stop="clickHandle(6, 1)"
              d="M227.06,11.05c10.38,1.66,15.33,8.66,19.07,17.84c32.58,79.95,65.42,159.78,98.13,239.67
		c8.06,19.68,10.61,40.25,9.44,61.37c-0.6,3.7-0.98,7.42-0.98,11.18c-7.47,50.86-50.4,94.57-102.13,104.51
		c-6.1,1.17-12.17,2.58-18.46,2.44c-4.39-0.09-6.63-2.12-6.64-6.56c0-1.88-0.03-3.77-0.03-5.65c0-138.34-0.01-276.68,0.04-415.01
		C225.51,17.53,224.58,13.99,227.06,11.05z"
            />
            <path
              class="flower_type_6_color2"
              @click.stop="clickHandle(6, 2)"
              d="M94.92,329.91c-2.04-27.4,5.36-52.68,15.9-77.67c31.79-75.44,62.94-151.14,94.33-226.75
		c2.91-7,7.4-12.18,15.21-13.71c2.02,1.95,1.67,4.5,1.67,6.91c0.02,140.47,0.02,280.94,0.01,421.41c0,1.51,0.06,3.02-0.35,4.48
		c-1.7,4.33-5.53,3.39-8.7,3.08c-18.19-1.79-35.56-6.59-51.51-15.61c-31.98-18.08-53.32-44.71-63.36-80.17
		c-1.17-4.13-2.21-8.34-2.22-12.7C95.71,336.08,95.47,332.98,94.92,329.91z"
            />
            <path
              class="st437"
              d="M96.98,338.92c2.2,16.43,8.13,31.49,16.79,45.52c18.04,29.26,43.75,48.45,76.76,57.69
		c9.7,2.71,19.66,4.72,29.9,4.18c2.32-2.1,1.6-4.89,1.6-7.45c0.04-47.11,0.03-94.22,0.03-141.33c0-92.52-0.01-185.04,0.03-277.56
		c0-3.12-0.79-6.49,1.79-9.14c1.06,0.07,2.13,0.14,3.19,0.21c0.03,52.98,0.07,105.96,0.08,158.94c0.01,89.75,0,179.5,0,269.24
		c0,7.26,0.05,7.75,7.48,7.05c25.24-2.36,48.27-10.7,68.4-26.42c26.24-20.5,42.67-46.97,48.61-79.83c3.05,1.4,1.4,3.78,1.22,5.86
		c-1.89,27.89-12.68,52.18-30.98,72.9c-27.76,31.42-63.04,45.99-104.88,44.42c-57.91-2.18-110.3-48.39-119.95-105.54
		c-0.66-3.89-1.52-7.76-1.27-11.75C95.81,343.53,93.65,340.74,96.98,338.92z"
            />
            <path
              class="st438"
              d="M223.87,10.83c-0.04,2.45-0.12,4.9-0.12,7.34c-0.01,140.54,0.01,281.08-0.12,421.62
		c0,2.28,2.39,6.63-3.2,6.52c-0.03-44.7-0.07-89.4-0.08-134.09c-0.01-100.15,0-200.29,0-300.44
		C221.24,10.39,222.6,10.78,223.87,10.83z"
            />
            <path
              class="st440"
              d="M352.85,345.9c-0.53-1.93,0.69-4.22-1.22-5.86c-0.14-3.54,0.94-6.83,2.06-10.11
		C353.75,335.27,354.59,340.65,352.85,345.9z"
            />
            <path
              class="st463"
              d="M96.98,338.92c-2.07,2.04-0.56,4.71-1.23,7c-1.74-5.26-0.88-10.66-0.83-16.01
		C96.3,332.76,96.52,335.87,96.98,338.92z"
            />
          </g>
        </svg>
      </template>
      <template v-if="len === 3">
        <svg
          version="1.1"
          class="flower_type_6 flower_type"
          :class="`flower_type_${name}`"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <g>
            <path
              class="flower_type_6_color1"
              @click.stop="clickHandle(6, 3)"
              d="M132.3,197.67c7.68-13.11,12.42-27.52,18.27-41.43c19.42-46.19,38.62-92.46,57.61-138.83
		c3.47-8.46,10.63-11.4,17.85-14.81c2.31,0,4.62,0,6.94,0c9.83,2.99,14.92,10.05,18.63,19.36c12.71,31.93,25.34,63.93,39.31,95.31
		c12.17,27.32,23.17,55.09,34.67,82.68c1.18,3.59-1.92,4.16-3.93,5.23c-9.99,5.36-20.05,10.6-30.18,15.7
		c-19.05,9.6-37.67,20.03-56.5,30.06c-5.14,2.74-9.21,2.5-14.44-0.28c-29.04-15.43-56.87-32.97-85.63-48.86
		C133.31,200.93,131,200.4,132.3,197.67z"
            />
            <path
              class="flower_type_6_color2"
              @click.stop="clickHandle(6, 1)"
              d="M327.77,204.43c8.51,20.94,17.17,41.82,25.49,62.83c7.76,19.59,10.19,40.04,9,60.99
		c-0.51,3.45-0.94,6.91-0.99,10.41c-3.13,23.59-13.53,43.91-28.48,62.04c-23.96,29.06-55.69,43.4-92.49,47.64
		c-3.66,0.42-8.25,1.94-10.89-2.78c-0.63-1.88-0.49-3.81-0.49-5.73c-0.01-57.87-0.01-115.75,0-173.62c0-1.73-0.1-3.46,0.27-5.16
		c0.45-2.31,2.18-3.46,4.09-4.5c21.13-11.42,41.93-23.43,63.46-34.1c9.12-4.52,17.85-9.8,26.88-14.52c1.4-0.73,2.48-1.78,3.41-3.03
		C327.28,204.74,327.53,204.58,327.77,204.43z"
            />
            <path
              class="flower_type_6_color3"
              @click.stop="clickHandle(6, 2)"
              d="M94.41,328.25c-2.13-28.13,4.89-54.34,16.55-79.64c6.33-13.73,11.07-28.15,17.89-41.68
		c4.51-1.57,7.75,1.57,11.1,3.4c11.15,6.1,22.04,12.66,33.19,18.76c14.86,8.14,29.15,17.32,44.45,24.64
		c5.78,2.77,7.88,6.79,7.86,13.22c-0.2,57.33-0.1,114.66-0.13,172c0,9.08-1.66,10.47-10.55,9.44
		c-28.97-3.36-54.13-14.66-76.51-33.62c-20.35-17.24-33.15-38.57-40.55-63.66c-1.24-4.21-2.11-8.56-2.32-12.98
		C95.24,334.82,94.97,331.52,94.41,328.25z"
            />
            <path
              class="st20"
              d="M96.51,337.43c2.28,16.79,8.26,32.23,17.24,46.53c18.92,30.14,46.24,49.08,80.06,58.96
		c7.48,2.18,15.41,2.82,23.14,4.11c5.04,0.84,6.92-0.82,6.9-6.42c-0.22-57.91-0.27-115.82,0.06-173.73
		c0.04-6.54-2.43-9.76-7.74-12.25c-17.57-8.26-33.81-18.96-50.9-28.1c-12.16-6.5-23.5-14.51-36.41-19.6
		c0.47-1.44,0.95-2.88,1.42-4.32c3.41-1.48,5.94,0.73,8.54,2.2c24.29,13.74,48.31,27.95,72.61,41.66c3.35,1.89,6.86,3.43,10.2,5.35
		c5.01,2.89,7.51,6.8,7.27,12.68c-0.23,5.76-0.05,11.54-0.05,17.31c0,52.69-0.03,105.39,0.07,158.08c0,2.45-1.31,5.51,1.87,7.25
		c30.4-0.37,57.91-9.88,81.57-28.53c25.88-20.4,42.07-47.28,47.78-80.04c3.12,1.43,1.43,3.87,1.25,5.98
		c-1.95,28.46-12.9,53.32-31.7,74.42c-50.86,57.09-136.65,60.65-193.18,9.08c-24.21-22.09-37.23-49.19-41.25-81.17
		c-0.1-0.75,0-1.53,0-2.3C95.31,342.13,93.12,339.3,96.51,337.43z"
            />
            <path
              class="st21"
              d="M230.8,447.14c-1.72,1.45-3.16,1.64-3.54-1.06c-0.21-1.51-0.08-3.07-0.08-4.61c0-58.6-0.25-117.2,0.26-175.79
		c0.08-8.81-4.77-11.76-10.75-14.83c-22.4-11.49-43.7-24.88-65.64-37.16c-6.85-3.83-13.32-8.41-20.79-11.08
		c-0.21-2.01,0.68-3.56,2.02-4.94c4.78,4.73,11.04,7.15,16.69,10.47c20.83,12.27,41.86,24.22,62.84,36.23
		c4.31,2.47,8.86,4.55,13.1,7.12c2.69,1.63,4.69,0.51,6.92-0.67c19.85-10.54,39.69-21.09,59.57-31.57
		c9.84-5.19,19.77-10.21,29.63-15.36c1.79-0.94,4.18-1.3,4.52-3.94c1.25,1.24,1.94,2.75,2.2,4.48c0.01,0.22,0,0.43-0.04,0.65
		c-9.34,6.47-19.57,11.39-29.68,16.41c-21.17,10.52-41.66,22.29-62.62,33.18c-1.92,1-3.48,2.37-4.68,4.16
		C230.76,321.6,230.78,384.37,230.8,447.14z"
            />
            <path
              class="st22"
              d="M361.4,344.55c-0.55-1.97,0.7-4.31-1.25-5.98c-0.14-3.61,0.96-6.97,2.11-10.32
		C362.33,333.7,363.19,339.2,361.4,344.55z"
            />
            <path
              class="st23"
              d="M96.51,337.43c-2.1,2.09-0.58,4.8-1.24,7.14c-1.77-5.36-0.91-10.87-0.85-16.33
		C95.8,331.15,96.05,334.32,96.51,337.43z"
            />
            <path
              class="st24"
              d="M230.75,258.83c-0.5-2.51,0.78-3.81,2.91-4.9c21.12-10.83,41.61-22.84,62.99-33.2
		c9.47-4.59,18.64-9.82,27.94-14.77c0.99-0.53,1.84-1.45,3.13-0.88c0.37,2.52-1.57,3.19-3.26,4.09
		c-17.22,9.16-34.45,18.29-51.63,27.52c-12.14,6.52-24.18,13.22-36.3,19.77C234.72,257.45,232.69,258.05,230.75,258.83z"
            />
          </g>
        </svg>
      </template>
    </template>

    <!-- 第七种类型 -->
    <template v-if="index === 7">
      <template v-if="len === 1">
        <svg
          version="1.1"
          class="flower_type_7 flower_type"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <g>
            <path
              class="st0"
              @click.stop="clickHandle(7, 1)"
              d="M20.68,289.35c-2.61-50.35,13.17-93.52,50.35-128.2c17.53-16.35,38.84-26.19,60.75-35.18
		c81.69-33.54,163.27-67.38,244.88-101.1c8.29-3.42,16.74-6.51,24.81-10.38c21-10.05,42.59,3.07,38.11,28.13
		c-3,15.86-10.97,29.85-17.02,44.53c-19.76,47.95-39.72,95.82-60.02,143.55c-16.6,39.04-30.61,79.29-50.12,116.97
		c-24.32,46.97-63.75,74.59-116.27,82.08c-42.96,6.13-82.17-4.39-116.58-30.79c-27.92-21.43-46.5-49.56-55.57-83.71
		c-1.08-4.06-2.12-8.23-2.19-12.52C21.11,298.3,21.49,293.78,20.68,289.35z"
            />
            <path
              class="st1"
              d="M23.12,302.73c4.97,28.5,17.38,53.27,36.48,75c24.22,27.55,54.56,44.28,90.38,49.89
		c43.29,6.78,83.1-2.89,118.39-29.63c25.84-19.58,42.1-45.8,54.12-75.36c16.28-40.02,33.21-79.79,49.86-119.66
		c15.27-36.57,30.53-73.15,45.83-109.7c7.08-16.91,14.26-33.77,21.4-50.66c1.75,12.18-1.39,23.22-6.15,34.5
		c-39,92.39-77.01,185.19-116.49,277.37c-23.54,54.96-66.05,86.69-125.7,93.95C112.63,458,35.79,403.29,22.17,318.47
		c-0.46-2.86-0.35-5.82-0.5-8.73C21.5,307.27,19.48,304.42,23.12,302.73z"
            />
            <path
              class="st3"
              d="M23.12,302.73c-2.25,1.97-0.81,4.7-1.45,7c-2.22-6.7-0.97-13.57-0.99-20.38
		C21.5,293.81,22.31,298.27,23.12,302.73z"
            />
          </g>
        </svg>
      </template>
      <template v-if="len === 2">
        <svg
          version="1.1"
          class="flower_type_7 flower_type"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <g>
            <path
              class="flower_type_7_color1"
              @click.stop="clickHandle(7, 2)"
              d="M16.49,292.42c-2.6-50.15,13.11-93.15,50.14-127.69c17.46-16.28,38.67-26.1,60.49-35.06
		c81.37-33.4,162.61-67.11,243.9-100.69c9.9-4.09,19.67-8.57,29.78-12.09c9.61-3.35,18.92-2.51,26.48,5.45
		c0.39,0.36,0.52,0.71,0.39,1.06c-0.14,0.35-0.27,0.52-0.4,0.53c-2.85-0.18-5.14,0.89-7.07,3.01c-1.5,1.65-3.15,3.17-4.73,4.75
		C299.86,147.3,184.24,262.93,68.62,378.55c-9.25,9.25-9.51,9.46-17.74-0.58c-17.45-21.29-29.64-45.1-33.26-72.77
		C16.75,300.98,17.39,296.63,16.49,292.42z"
            />
            <path
              class="flower_type_7_color2"
              @click.stop="clickHandle(7, 1)"
              d="M427.22,23.72c0.02-0.46,0.04-0.92,0.06-1.39c7.36,6.7,7.55,15.33,6.51,24.29
		c-2.98,15.81-10.9,29.77-16.96,44.38c-19.81,47.74-39.56,95.51-59.81,143.07c-16.47,38.7-30.57,78.49-49.69,115.97
		c-23.5,46.09-61.93,73.56-112.93,81.84c-43.86,7.13-83.91-3.56-119.53-30.32c-3.59-2.7-6.8-5.81-10.01-8.92
		c-1.61-2.93,1.1-3.95,2.53-5.38C185.19,269.67,302.78,151.87,420.46,34.17c2.03-2.03,5.61-3.58,3.87-7.65
		C424.01,24.26,425.84,24.22,427.22,23.72z"
            />
            <path
              class="st1"
              d="M64.67,391.72c5.53,1.4,8.37,6.42,12.62,9.54c21.87,16.09,46.03,26.09,73,29.45
		c43.97,5.48,83.22-5.86,117.49-33.62c19.56-15.84,34.12-35.85,43.91-59.09c17.59-41.75,34.91-83.62,52.42-125.4
		c23.19-55.35,46.45-110.66,69.67-165.99c1.74,12.14-1.38,23.13-6.13,34.36c-38.85,92.03-76.71,184.49-116.04,276.31
		c-23.45,54.75-65.8,86.36-125.23,93.59c-78.32,9.53-154.86-44.97-168.43-129.46c-0.46-2.85-0.35-5.79-0.5-8.69
		c-0.17-2.46-2.18-5.3,1.44-6.98c5.11,29.1,17.7,54.46,37.71,76.25c2.64,2.87,3.96,2.74,6.16,0.19c1.16-1.35,2.51-2.55,3.78-3.81
		C184,260.93,301.43,143.49,418.91,26.1c2.18-2.18,4.06-6.87,8.32-2.38c-0.89,0.84-1.77,1.67-2.66,2.5
		c-0.88,3.79-4.12,5.75-6.59,8.23C301.73,150.78,185.43,267.05,69.24,383.43C67.1,385.57,62.42,386.92,64.67,391.72z"
            />
            <path
              class="st3"
              d="M18.92,305.75c-2.24,1.96-0.81,4.68-1.44,6.98c-2.21-6.68-0.97-13.52-0.98-20.31
		C17.3,296.86,18.11,301.3,18.92,305.75z"
            />
            <path
              class="st2"
              d="M64.67,391.72c-2.89,0.25-4.22-0.68-2.4-3.52c0.71-1.11,1.85-1.94,2.8-2.89
		c118.5-118.51,237-237.01,355.52-355.51c1.26-1.26,2.65-2.39,3.98-3.58c2.52,0.43,4.86,0.97,2.04,4.06
		c-1.06,1.16-2.2,2.23-3.31,3.34C306.2,150.72,189.11,267.82,72,384.91C69.64,387.27,67.12,389.46,64.67,391.72z"
            />
          </g>
        </svg>
      </template>
      <template v-if="len === 3">
        <svg
          version="1.1"
          class="flower_type_7 flower_type"
          :class="`flower_type_${name}`"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 311.36 326.44"
          style="enable-background: new 0 0 311.36 326.44"
          xml:space="preserve"
        >
          <g>
            <path
              class="flower_type_7_color1"
              @click.stop="clickHandle(7, 2)"
              d="M0,183.81c1.8-3.42,1.55-7.29,2.41-10.93c9.49-39.74,33.86-66.67,71.08-82.47
		c15.39-6.54,30.92-12.75,46.39-19.11c1.91,0.69,2.03,2.49,2.46,4.05c7.28,26.43,14.69,52.83,21.94,79.28
		c1.13,4.11,0.2,6.83-2.71,9.73c-25.34,25.21-50.39,50.72-76.02,75.63c-10.61,10.3-21.1,20.72-31.75,30.98
		c-3.8,3.66-5.34,3.9-8.18,0.36c-14.44-18.02-24.61-37.83-25.12-61.56c-0.24-1.67,0.53-3.44-0.51-5.03C0,197.78,0,190.79,0,183.81z"
            />
            <path
              class="st1"
              d="M0.96,209.78c1.4,16.99,6.95,32.59,15.78,47.1c3.02,4.97,6.53,9.56,10.11,14.12c1.65,2.1,3.24,2.72,5.02,0.2
		c0.09-0.13,0.23-0.24,0.35-0.35c36.91-35.71,73.07-72.18,109.44-108.44c1.55-1.55,2.78-2.79,2.02-5.5
		c-8.04-28.5-15.89-57.06-23.79-85.6c0.95-0.39,1.91-0.79,2.86-1.18c2.29,0.89,2.26,3.13,2.76,4.97
		c7.19,26.46,14.26,52.95,21.61,79.37c1.41,5.06-0.13,8.48-3.64,11.97C107.99,201.71,71.82,236.28,36.77,272
		c-1.28,1.3-2.68,2.49-3.72,4.02c-0.88,1.3,0.11,1.72,1.03,2.17c2.21,0.88,3.98,2.37,5.73,3.93c20.43,18.29,44.52,27.35,71.8,28.02
		c27.12,0.66,51.43-7.35,72.7-24.28c15.69-12.49,27.08-28.18,34.81-46.63c5.72-13.64,11.3-27.34,17.12-40.94
		c2.39-5.59,2.35-5.75-3.5-7.5c-26.6-7.94-53.22-15.84-79.76-23.98c-1.8-0.55-4.11-0.52-4.76-3c1.53-4.39,4.9-3.21,7.83-2.33
		c12.08,3.63,24.15,7.27,36.2,10.99c14.43,4.44,28.87,8.85,43.34,13.17c1.86,0.55,4.04,2.2,5.86-0.28
		c9.41-21.26,18.11-42.81,27.09-64.24c12.83-30.62,25.75-61.21,38.49-91.86c0.64-1.53,0.51-4.53,3.76-3.58
		c0.1,2.21,0.03,4.42,0.05,6.63c-0.12,1.7,0.28,3.44-0.29,5.11c-1.76,8.86-6.16,16.75-9.57,24.96
		c-27.1,65.12-53.89,130.39-81.83,195.15c-16.35,37.89-46.21,60.09-86.79,67.83c-1.87,0.36-4.03-0.73-5.62,1.09
		c-8.65,0-17.3,0-25.95,0c-19.23-1.2-36.39-8.2-52.13-18.92c-23.78-16.21-38.79-38.67-46.53-66.19C0.7,236.23,1.04,230.87,0,225.7
		c0-5.32,0-10.64,0-15.96C0.34,209.29,0.66,209.3,0.96,209.78z"
            />
            <path
              class="st2"
              d="M310.54,31.98c-0.12-2.21-0.24-4.41-0.37-6.62c-0.54-0.66-0.48-1.36-0.11-2.07c0.41-0.36,0.84-0.38,1.29-0.07
		c0,2.99,0,5.98,0,8.98C310.94,32.66,310.67,32.59,310.54,31.98z"
            />
            <path
              class="st3"
              d="M296.39,1.28c-0.04,0.33-0.03,0.65,0.04,0.97c-2.4,1.86-4.78,1.89-7.14-0.07c0.05-0.3,0.09-0.6,0.12-0.9
		C291.73,1.28,294.06,1.28,296.39,1.28z"
            />
            <path
              class="st4"
              d="M311.36,23.22l-0.48,0l-0.48,0.04c-1.7-2.08-1.75-4.13,0.09-6.16c0.3-0.01,0.59,0.03,0.87,0.13
		C311.36,19.24,311.36,21.23,311.36,23.22z"
            />
            <path
              class="st5"
              d="M310.54,31.98c0.3-0.02,0.57,0.05,0.81,0.22c0,1.66,0,3.32,0,4.99c-0.24,0.18-0.51,0.26-0.81,0.23
		C310.55,35.61,310.55,33.8,310.54,31.98z"
            />
            <path
              class="st6"
              d="M0.96,209.78c-0.32-0.02-0.64-0.03-0.96-0.03c0-1.66,0-3.32,0-4.99C1.65,206.18,0.78,208.08,0.96,209.78z"
            />
            <path
              class="flower_type_7_color2"
              @click.stop="clickHandle(7, 3)"
              d="M310.49,17.11c-0.03,2.05-0.06,4.1-0.09,6.16c-0.07,0.7-0.14,1.4-0.22,2.1
		c-10.26,24.4-20.43,48.83-30.79,73.18c-12.36,29.07-23.91,58.47-36.94,87.26c-1.58,1.23-3.19,0.45-4.74-0.02
		c-27.33-8.28-54.56-16.91-81.9-25.17c-5.4-1.63-8.09-4.65-9.5-10.12c-6.53-25.22-13.38-50.35-20.11-75.52
		c-0.58-2.16-2.39-4.7,0.6-6.65c30.81-12.67,61.63-25.33,92.43-38.03c21.76-8.97,43.51-17.99,65.24-27.02
		c1.56-0.65,3.11-1.12,4.8-1.1c2.38,0.02,4.76,0.05,7.14,0.07C304.42,3.81,309.42,9.1,310.49,17.11z"
            />
            <path
              class="st7"
              d="M126.8,68.34c-0.53,7.1,2.68,13.45,4.34,20.05c5.36,21.28,11.45,42.37,16.98,63.61
		c0.96,3.69,2.58,5.6,6.19,6.7c29.41,8.95,58.77,18.05,88.15,27.1c-0.15,3.05-1.77,2.84-4.09,2.13
		c-19.16-5.89-38.36-11.68-57.54-17.51c-8.72-2.65-17.43-5.34-26.15-8.03c-2.33-0.72-4.58-1.26-6.09,1.44
		c-0.55,2.25-2.31,3.6-3.82,5.11c-35.12,35.12-70.24,70.22-105.37,105.33c-1.87,1.86-3.61,3.91-6.44,4.35
		c-2.72-1.16-2.8-1.22-1.78-2.62c0.67-0.93,1.61-1.67,2.43-2.49c23.14-23.11,46.04-46.45,69.5-69.23
		c13.69-13.29,27.06-26.9,40.78-40.16c2.23-2.16,3.44-4.3,2.58-7.44c-7.8-28.54-15.56-57.1-23.33-85.65
		c-0.09-0.32-0.26-0.61-0.39-0.92C123.55,68.28,125.02,67.96,126.8,68.34z"
            />
            <path
              class="flower_type_7_color3"
              @click.stop="clickHandle(7, 1)"
              d="M32.96,278.62c2.28-2.15,4.62-4.25,6.84-6.47c34.92-34.87,69.83-69.77,104.75-104.64
		c1.29-1.28,2.69-2.45,4.04-3.67c13.82,5.05,28.09,8.66,42.13,12.99c15.35,4.72,30.73,9.33,46.13,13.88
		c2.71,0.8,3.28,1.73,2.08,4.49c-8.52,19.59-15.08,40.13-25.68,58.7c-17.08,29.9-42.82,48.85-76.8,55.48
		c-34.26,6.69-65.37-1.25-93.16-22.25C39.73,284.45,37.05,280.68,32.96,278.62z"
            />
          </g>
        </svg>
      </template>
    </template>

    <!-- 第八种类型 -->
    <template v-if="index === 8">
      <template v-if="len === 1">
        <svg
          version="1.1"
          class="flower_type_8 flower_type"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <g>
            <path
              class="st442"
              @click.stop="clickHandle(8, 1)"
              d="M16.04,234.53c-2.32-36.16,5.86-69.27,29.49-97.5c22.66-27.07,51.69-42.59,87-46.42
		c22.72-2.46,44.3,1.59,65.18,10.24c79.56,32.93,159.09,65.91,238.64,98.86c11.72,4.85,16.01,11.67,15.44,24.64
		c-0.71,8.3-5.75,13.16-13.01,16.21c-28.16,11.82-56.49,23.24-84.75,34.83c-52.16,21.38-104.33,42.75-156.52,64.05
		c-19.09,7.79-38.92,12.07-59.63,10.64c-29.92-2.08-56.41-12.6-78.97-32.64c-19.39-17.22-32.77-38.14-39.72-63.14
		c-0.96-3.44-1.24-7.01-2.15-10.46C16.82,240.73,16.56,237.61,16.04,234.53z"
            />
            <path
              class="st443"
              d="M18.09,243.52c4.13,21.01,12.6,40.1,26.22,56.65c20.29,24.65,45.93,40.32,77.63,46.38
		c31.01,5.93,59.53-1.29,87.63-13.59c21.01-9.2,42.47-17.38,63.71-26.08c39.69-16.26,79.35-32.56,119.03-48.84
		c14.44-5.92,28.8-12.07,43.39-17.63c7.97-3.04,13.27-8.16,16.08-16.05c0.06,3.39,0.17,6.77,0.17,10.16
		c0,10.51-4.65,17.81-14.59,21.88c-81.36,33.26-162.58,66.88-244.07,99.82c-77.18,31.2-164.25-19.03-176.08-101.06
		c-0.32-2.22-0.24-4.5-0.34-6.74C16.73,246.63,15.05,244.49,18.09,243.52z"
            />
            <path
              class="st444"
              d="M18.09,243.52c-1.68,1.31-0.87,3.24-1.22,4.88c-1.54-4.55-0.94-9.22-0.83-13.87
		C17.41,237.37,17.61,240.47,18.09,243.52z"
            />
          </g>
        </svg>
      </template>
      <template v-if="len === 2">
        <svg
          version="1.1"
          class="flower_type_8 flower_type"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <g>
            <path
              class="flower_type_8_color1"
              @click.stop="clickHandle(8, 1)"
              d="M20.88,232.33c-3.1-61.4,44.06-119.06,104.86-128.82c25.38-4.08,49.6-0.89,73.16,8.9
		c78.05,32.42,156.1,64.85,234.18,97.22c8.83,3.66,14.24,9.62,14.59,19.5c-2.47,2.35-5.58,1.58-8.45,1.58
		c-51.72,0.04-103.44,0.03-155.15,0.03c-84.41,0-168.82-0.01-253.23,0.04c-2.67,0-5.59-0.92-7.96,1.25
		C22.27,232.55,21.6,232.65,20.88,232.33z"
            />
            <path
              class="flower_type_8_color2"
              @click.stop="clickHandle(8, 2)"
              d="M20.88,241.35c0-1.85,0-3.69,0-5.54c2.61-2.53,5.91-1.7,8.97-1.7c129.67-0.04,259.33-0.04,389,0
		c8.67,0,17.35-0.47,26,0.33c3.96,1.65,1.85,4.35,0.75,6.37c-2.4,4.39-6.48,6.97-10.99,8.91c-16.13,6.93-32.44,13.46-48.69,20.1
		c-62.63,25.58-125.16,51.39-187.8,76.95c-30.65,12.5-61.91,14.49-93.11,2.98c-41.83-15.43-69.01-45.02-81.35-87.97
		c-0.95-3.32-1.64-6.79-1.83-10.3C21.47,248.11,21.42,244.71,20.88,241.35z"
            />
            <path
              class="st443"
              d="M22.89,251.3c4.22,24.02,14.67,44.87,31.18,62.89c17.7,19.32,39.11,32.05,64.56,38.11
		c26.68,6.35,52.66,3.73,77.9-6.48c40.47-16.37,80.86-32.94,121.24-49.53c38.85-15.96,77.62-32.12,116.49-48.04
		c6.06-2.48,10.03-6.63,12.58-12.44c0.31-0.4,0.61-0.41,0.91,0.01c0.05,2.21,0.15,4.43,0.15,6.64
		c-0.01,12.14-4.24,18.47-15.32,23.01c-54.26,22.24-108.51,44.5-162.79,66.7c-26.96,11.03-53.55,23.17-81.05,32.68
		c-75.2,25.99-153.92-21.91-166.61-100.49c-0.38-2.35-0.32-4.78-0.46-7.17C21.62,255.14,19.79,252.71,22.89,251.3z"
            />
            <path
              class="st459"
              d="M447.75,235.83l-0.45-0.04c0,0-0.45,0.03-0.45,0.03c-51.4-0.03-102.79-0.08-154.19-0.07
		c-90.59,0.01-181.18,0.05-271.77,0.07c0-1.16,0-2.32,0-3.48c0.33,0.02,0.67,0,1-0.04c1.98-1.83,4.46-1.53,6.84-1.53
		c137.4-0.01,274.8-0.01,412.2,0c2.37,0,4.86-0.35,6.82,1.55C447.75,233.49,447.75,234.66,447.75,235.83z"
            />
            <path
              class="st443"
              d="M447.75,232.32c-14.23,0.03-28.46,0.09-42.7,0.09c-125.32,0.01-250.65,0-375.97,0c-2.4,0-4.8-0.07-7.2-0.11
		c-0.04-1.56,0.03-3.05,2.13-3.16c0.92-0.05,1.85-0.05,2.77-0.05c140.3,0.01,280.59,0.03,420.89,0.04
		C447.69,230.19,447.72,231.25,447.75,232.32z"
            />
            <path
              class="st460"
              d="M22.89,251.3c-1.87,1.66-0.66,3.97-1.23,5.9c-1.6-5.22-0.92-10.55-0.78-15.85
		C21.55,244.67,22.22,247.99,22.89,251.3z"
            />
          </g>
        </svg>
      </template>
      <template v-if="len === 3">
        <svg
          version="1.1"
          class="flower_type_8 flower_type"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <g>
            <path
              class="flower_type_8_color1"
              @click.stop="clickHandle(8, 3)"
              d="M260.18,144.82c58.25,24.16,116.52,48.28,174.75,72.5c9.68,4.03,13.63,11.45,13.11,23.33
		c-0.71,8.17-5.69,12.94-12.79,15.96c-24.39,10.34-48.97,20.22-73.48,30.27c-32.05,13.15-64.09,26.3-96.16,39.41
		c-2.39,0.98-4.72,2.21-7.44,1.96c-2.08-0.44-2.91-2.15-3.77-3.79c-11.99-22.77-24.44-45.29-36.31-68.12
		c-3.07-5.91-6.55-11.61-9.41-17.64c-1.5-3.17-1.45-5.93,0.3-8.92c16.07-27.49,31.86-55.15,47.98-82.61
		C257.65,146,258.14,144.27,260.18,144.82z"
            />
            <path
              class="flower_type_8_color2"
              @click.stop="clickHandle(8, 1)"
              d="M19.94,249.55c-0.01-4.08-0.01-8.16-0.02-12.24c1.73-1.81,3.99-1.72,6.22-1.72
		c57.02-0.01,114.05-0.02,171.07,0.01c1.11,0,2.22,0.03,3.29,0.32c3.07,0.82,4.13,3.59,5.43,5.97
		c9.86,18.04,19.74,36.07,29.53,54.15c5.38,9.94,10.92,19.78,16.17,29.79c1.73,3.3,1.62,5.67-2.07,7.07
		c-23.89,9.05-46.59,21.46-71.52,27.52c-44.02,10.71-83.34,0.73-117.22-29.43c-21.46-19.1-35-42.83-39.92-71.29
		C20.51,256.32,20.49,252.91,19.94,249.55z"
            />
            <path
              class="flower_type_8_color3"
              @click.stop="clickHandle(8, 2)"
              d="M19.95,233.81c0.32-31.12,10.79-58.53,31.26-81.76c26.27-29.82,59.74-44.18,99.45-43.72
		c14,0.16,27.71,2.89,40.69,8.01c20.49,8.09,40.71,16.86,61.04,25.35c1.38,2.68-0.54,4.64-1.66,6.62
		c-14.46,25.43-28.88,50.89-43.28,76.36c-3.13,5.53-7.04,7.63-13.37,7.61c-54.82-0.19-109.64-0.13-164.45-0.06
		c-2.66,0-5.62-0.97-7.89,1.44C21.17,234.12,20.58,234.17,19.95,233.81z"
            />
            <path
              class="st443"
              d="M21.95,259.5c4.06,20.67,12.37,39.44,25.74,55.73c19.91,24.26,45.08,39.69,76.19,45.68
		c30.43,5.86,58.53-1.05,86.04-13.34c12.64-5.65,25.6-10.6,38.5-15.66c3.04-1.2,3.98-1.81,2.04-5.31
		c-15.87-28.63-31.45-57.41-47.09-86.17c-0.52-0.95-0.71-2.07-1.05-3.11c3.63-2.18,4.99,0.67,6.3,3.04
		c5.07,9.27,10.15,18.54,15.07,27.88c9.59,18.21,19.62,36.17,29.07,54.45c1.06,2.05,1.59,5.22,5.19,4.69
		c16.98-5.72,33.22-13.28,49.81-19.99c40.38-16.33,80.64-32.94,120.99-49.33c8.63-3.5,16.41-7.67,19.29-17.42
		c0.06,3.7,0.27,7.41,0.15,11.11c-0.32,9.62-4.72,16.45-13.82,20.18c-80.29,32.91-160.36,66.36-240.9,98.65
		c-75.73,30.36-159.69-18.45-172.31-99.23c-0.31-2-0.29-4.06-0.42-6.09c-0.71-1.77-0.36-3.6-0.29-5.42
		C20.83,259.23,21.33,259.11,21.95,259.5z"
            />
            <path
              class="st453"
              d="M257.94,327.39c-3.44,3.88-4.34-0.22-5.31-2c-6.41-11.69-12.61-23.49-18.89-35.26
		c-8.81-16.5-17.65-32.98-26.41-49.5c-1.12-2.11-2.22-3.9-5.01-3.32c-60.8,0-121.6-0.01-182.39-0.01c0.01-1.16,0.02-2.33,0.03-3.49
		c0.33,0.01,0.66-0.01,0.99-0.05c2.77-2.15,6.04-1.45,9.12-1.45c54.85-0.04,109.7-0.12,164.55,0.11c6.11,0.03,9.69-1.69,12.78-7.13
		c14.45-25.46,29.15-50.77,43.79-76.12c1.29-2.23,2.17-4.75,4.38-6.34c1.89-0.16,3.43,0.49,4.6,1.99
		c-8.79,14.96-17.6,29.91-26.35,44.89c-7.74,13.24-15.36,26.54-23.15,39.75c-1.8,3.05-2.57,5.57-0.64,9.14
		c15.73,29.13,31.21,58.39,46.79,87.6C257.07,326.66,257.57,327,257.94,327.39z"
            />
            <path
              class="st443"
              d="M255.57,142.83c-1.32,6.71-5.76,11.89-8.99,17.6c-12.94,22.87-26.28,45.52-39.43,68.27
		c-1.75,3.02-3.62,5.26-7.68,5.25c-59.51-0.13-119.01-0.15-178.52-0.19c-0.32-4.07,2.69-3.18,4.92-3.19
		c21.85-0.04,43.7-0.02,65.54-0.02c34.62,0,69.25-0.09,103.87,0.1c4.78,0.03,7.56-1.15,10.02-5.59
		c15.49-27.91,31.35-55.61,47.08-83.38C253.45,142.07,254.51,142.45,255.57,142.83z"
            />
            <path
              class="st444"
              d="M21.95,259.5c0,0-0.52,0-0.52,0l-0.52,0c-0.86-0.5-0.41-1.58-0.97-2.21c0-2.58,0-5.16-0.01-7.74
		C20.61,252.87,21.28,256.18,21.95,259.5z"
            />
            <path
              class="st442"
              d="M19.95,257.29c0.32,0.74,0.64,1.47,0.97,2.21c-0.06,1.92-0.12,3.84-0.18,5.76
		C19.46,262.7,19.77,259.99,19.95,257.29z"
            />
          </g>
        </svg>
      </template>
    </template>

    <!-- 第九种类型 -->
    <template v-if="index === 9">
      <template v-if="len === 1">
        <svg
          version="1.1"
          class="flower_type_9 flower_type"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <g>
            <path
              class="st429"
              @click.stop="clickHandle(9, 1)"
              d="M15.19,204.46c-2.37-14.62-1.84-29.42-0.66-43.97C18.7,109.47,42.45,69.57,85.81,42.2
		c73.12-46.15,171.81-19.47,211.9,57.23c14.34,27.43,24.45,56.78,36.33,85.32c28.99,69.66,57.59,139.48,86.44,209.2
		c2.14,5.17,3.38,10.4,3.31,15.96c-0.71,17.81-19.33,25.6-35.25,19.4c-18.41-7.17-36.51-15.07-54.73-22.71
		c-50.8-21.29-101.66-42.42-152.4-63.86c-28.29-11.95-57.2-22.54-84.73-36.2C56.53,286.62,30.9,254.27,18,211.57
		c-0.63-2.1-1.33-4.2-1.27-6.43c0.06-2.14-0.61-4.19-0.74-6.51C15.74,200.72,17.25,202.83,15.19,204.46z"
            />
            <path
              class="st430"
              d="M15.19,204.46c0.13-2.61,0.26-5.23,0.45-9.15c2.36,8.93,3.87,16.83,6.57,24.3
		c2.83,7.8,6.48,15.36,10.35,22.71c13.98,26.54,34.4,46.93,60.93,60.71c25.67,13.34,52.98,23.05,79.59,34.29
		c34.27,14.48,68.58,28.89,102.89,43.27c30.68,12.86,61.39,25.64,92.09,38.45c6.06,2.53,12.15,4.99,18.21,7.51
		c18.34,7.62,31.27,1.9,37.5-16.63c0.04,7.18,1.38,14.4-0.95,21.48c-5.13,15.6-18.66,22.08-33.84,15.8
		c-34.25-14.18-68.43-28.52-102.62-42.83c-59.89-25.06-120.01-49.6-179.59-75.37c-51.47-22.27-81.62-62.02-91.16-117.31
		C15.22,209.32,15.32,206.87,15.19,204.46z"
            />
          </g>
        </svg>
      </template>
      <template v-if="len === 2">
        <svg
          version="1.1"
          class="flower_type_9 flower_type"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <g>
            <path
              class="flower_type_9_color1"
              @click.stop="clickHandle(9, 1)"
              d="M64.22,64.49c23.44-24.58,52.44-38.84,85.71-43.16c52.01-6.74,96.57,9.29,132.83,47.45
		c12.44,13.09,21.78,28.32,28.66,44.94C350.34,207.77,389.1,301.88,428,395.94c2.15,5.19,3.39,10.44,3.33,16.03
		c-0.62,1.25-0.25,2.61-0.45,3.9c-0.54,3.38-1.62,6.8-4.9,8.15c-3.59,1.47-5.54-1.95-7.62-4.03
		C301.57,303.28,184.82,186.51,68.08,69.75C66.53,68.2,64.77,66.78,64.22,64.49z"
            />
            <path
              class="flower_type_9_color2"
              @click.stop="clickHandle(9, 2)"
              d="M20.65,205.47c-2.34-15.3-1.69-30.73-0.54-45.99c2.55-33.93,15.57-63.72,38.08-89.3
		c1.77-0.71,2.94,0.45,4.11,1.42c1.7,1.41,3.19,3.04,4.76,4.6C182.21,191.36,297.38,306.53,412.5,421.74
		c2.4,2.41,5.81,4.22,6.16,8.23c-7.4,5.91-15.47,4.12-23.13,1.26c-18.4-6.85-36.33-14.92-54.44-22.5
		c-51.28-21.48-102.62-42.81-153.83-64.46c-28.65-12.11-57.96-22.75-85.75-36.76c-40.26-20.28-65.7-53.07-78.4-96.06
		c-1.13-3.83-0.83-7.82-1.59-11.41C20.95,201.6,22.84,203.88,20.65,205.47z"
            />
            <path
              class="st430"
              d="M20.65,205.47c0.13-2.63,0.26-5.26,0.39-7.88c3.29,13.16,7.22,26.01,13.07,38.34
		c18.26,38.5,48.41,63.42,87.38,79.13c35.1,14.15,69.83,29.19,104.75,43.79c30.86,12.9,61.75,25.7,92.62,38.58
		c25.38,10.59,50.74,21.26,76.12,31.86c7.79,3.25,15.62,4.27,23.36-0.27c0.52-3.91-2.31-5.99-4.62-8.3
		c-25.12-25.15-50.27-50.28-75.4-75.42C248.07,255.05,157.82,164.81,67.63,74.51c-2.34-2.35-6-4.06-5.55-8.35
		c0.72-0.56,1.43-1.11,2.15-1.67c2.15,1.88,4.41,3.64,6.42,5.66C186.49,185.96,302.32,301.8,418.19,417.59
		c2.1,2.1,4.06,6.37,6.87,5.32c3.29-1.22,5-5.27,5.33-9.25c0.05-0.59,0.61-1.13,0.93-1.69c0.04,7.21,1.39,14.47-0.95,21.59
		c-5.16,15.68-18.76,22.19-34.01,15.88c-34.42-14.25-68.78-28.67-103.15-43.05c-60.2-25.19-120.62-49.85-180.5-75.76
		c-51.73-22.38-82.03-62.33-91.62-117.9C20.68,210.35,20.79,207.89,20.65,205.47z"
            />
            <path
              class="st433"
              d="M62.07,66.15c1.87,2.15,3.62,4.41,5.63,6.42c116.16,116.2,232.35,232.37,348.41,348.68
		c1.71,1.72,7.9,3.43,2.22,7.76c-1.96-1.76-4.01-3.43-5.87-5.29C296.5,307.78,180.54,191.81,64.57,75.87
		c-2.01-2.01-4.25-3.8-6.38-5.69C58.58,67.96,59.94,66.68,62.07,66.15z"
            />
          </g>
        </svg>
      </template>
      <template v-if="len === 3">
        <svg
          version="1.1"
          class="flower_type_9 flower_type"
          xmlns:x="&ns_extend;"
          xmlns:i="&ns_ai;"
          xmlns:graph="&ns_graphs;"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 468 467"
          style="enable-background: new 0 0 468 467"
          xml:space="preserve"
        >
          <g>
            <path
              class="flower_type_9_color1"
              @click.stop="clickHandle(9, 3)"
              d="M446.55,396.91c0,0.43,0,0.86,0,1.3c-3.59,18.11-18.95,25.96-37.72,18.8
		c-33.04-12.62-65.74-26.05-98.6-39.09c-34.75-13.78-69.41-27.75-104.18-41.48c-4.15-1.64-8.6-2.78-12.07-5.76
		c-0.97-2.2-0.07-4.25,0.59-6.3c11.12-34.89,22.8-69.62,33.74-104.57c2.27-7.27,6.41-10.81,14.17-12.72
		c34.88-8.61,69.68-17.51,104.45-26.55c2.6-0.68,5.2-1.63,7.99-0.86c3.22,2.09,4.25,5.53,5.61,8.68
		c27.26,63.16,54.84,126.2,82.05,189.39c1.73,4.01,3.36,8.03,3.28,12.47C446.17,392.44,445.13,394.79,446.55,396.91z"
            />
            <path
              class="flower_type_9_color2"
              @click.stop="clickHandle(9, 2)"
              d="M195.87,14.32c6.61,2.86,13.92,2.71,20.81,4.47c49.63,12.72,84.8,41.65,105.58,86.12
		c10.39,22.23,19.39,45.04,29.01,67.59c-0.89,2.48-3.31,2.74-5.45,3.29c-35.21,9.21-70.43,18.4-105.56,27.87
		c-7.8,2.1-13.32,0.29-18.86-5.03c-30.99-29.76-62.61-58.92-93.09-89.13c-16.97-16.82-34.44-33.15-51.46-49.92
		c-1.56-1.54-3.43-2.88-3.86-5.19c21.62-20.27,47.9-31.78,77.31-37.56c3.84-0.75,8.07-0.06,11.51-2.51c3.18,0,6.36,0,9.54,0
		c5,1.06,9.99,1.06,14.99,0C189.51,14.32,192.69,14.32,195.87,14.32z"
            />
            <path
              class="st430"
              d="M194.34,330.64c13.28,3.63,25.61,9.55,38.33,14.5c32.83,12.79,65.48,25.97,98.21,39
		c25.22,10.04,50.39,20.2,75.69,30.07c20.36,7.94,31.49,3.34,39.97-16c0,6.48,0,12.97,0,19.45c-1.99,1.7-1.85,4.29-2.91,6.38
		c-5.88,11.55-19.61,16.38-33,11.1c-32.02-12.62-63.95-25.44-95.92-38.17c-65.4-26.05-131.05-51.55-196.13-78.31
		c-53.16-21.86-84.26-60.99-94.12-115.34c-0.42-2.32-0.28-4.73-0.4-7.1c-0.62-2.78-1.23-5.55,0.35-8.24
		c3.53,0.37,3.06,3.38,3.56,5.39c13.09,52.36,46.56,87.69,98.65,107.72c16.83,6.47,33.52,13.29,50.23,20.06
		c9.97,4.04,10.01,3.97,13.2-6.25c10.01-32.1,20.19-64.15,30.33-96.21c0.97-3.05,1.45-6.39,4.03-8.8c5.34,0.59,5.02,3.97,4.1,7.61
		c-2.12,8.41-5.06,16.6-7.82,24.82c-8.99,26.74-17.2,53.71-26.2,80.44C193.67,325.27,191.74,327.98,194.34,330.64z"
            />
            <path
              class="st431"
              d="M186.33,14.32c-5,2.1-9.99,2.1-14.99,0C176.34,14.32,181.34,14.32,186.33,14.32z"
            />
            <path
              class="st432"
              d="M445.41,390.25c0.39-0.02,0.77,0.03,1.14,0.18c0,2.16,0,4.32,0,6.48
		C444.28,394.99,445.4,392.53,445.41,390.25z"
            />
            <path
              class="flower_type_9_color3"
              @click.stop="clickHandle(9, 1)"
              d="M224.49,210.09c-4.52,14.84-8.96,29.71-13.57,44.53c-6.86,22.05-13.92,44.04-20.69,66.11
		c-1.5,4.9-3.05,6.49-8.84,4.06c-25.21-10.6-51.51-18.96-75.83-31.35c-43.47-22.14-69.7-56.91-79.92-102.73
		c-0.18-0.83-0.06-1.72-0.08-2.58c-2.52-2.59-1.44-6.08-2.49-9.04C20.23,133.6,33.11,93.31,66.59,59.83
		c3.07-0.75,4.53,1.57,6.2,3.16c49.49,47.03,98.93,94.1,148.34,141.2C222.79,205.79,225.21,207.18,224.49,210.09z"
            />
            <path
              class="st433"
              d="M224.49,210.09c-1-1.16-1.91-2.41-3.02-3.46c-50.22-47.86-100.46-95.7-150.72-143.53
		c-1.27-1.2-2.77-2.18-4.16-3.27c0.55-2.07,1.89-3.38,4.09-3.85c3.05,0.74,4.89,3.04,6.97,5c27.43,25.8,54.68,51.79,81.48,78.18
		c20.97,20.65,42.65,40.63,63.57,61.31c4.64,4.59,9.03,5.71,15.68,3.98c38.06-9.89,76.14-19.7,114.26-29.38
		c1.56,1.48,2.65,3.15,2.42,5.36c-39.05,9.91-78.08,19.86-117.15,29.68c-3.22,0.81-5.04,2.23-6.02,5.25
		c-11.05,34.13-22.18,68.24-33.29,102.35c-1.41,4.31-2.84,8.62-4.26,12.93c-4.43-0.3-3.48-2.79-2.6-5.48
		c8.87-27.05,17.69-54.11,26.5-81.17c2.94-9.02,5.74-18.07,8.77-27.06C228.06,213.87,227.99,211.49,224.49,210.09z"
            />
            <path
              class="st434"
              d="M352.64,175.08c-0.89,2.15-2.91,2.33-4.93,2.84c-37.57,9.64-75.13,19.35-112.67,29.07
		c-3.74,0.97-6.84,0.81-9.88-2.11c-50.95-48.96-102-97.83-153-146.75c-0.62-0.59-0.99-1.43-1.47-2.15c0.77-0.53,1.54-1.06,2.31-1.59
		c18.16,16.22,36.01,32.72,52.64,50.39c1.21,1.28,2.44,2.55,3.72,3.77c31.41,29.91,62.89,59.76,94.17,89.79
		c4.46,4.28,8.68,5.81,15.02,4.1c37.52-10.16,75.15-19.99,112.73-29.93C351.73,173.36,352.19,174.22,352.64,175.08z"
            />
            <path
              class="st435"
              d="M23.07,179.09c1.47,2.85,2.3,5.87,2.49,9.04c-2.51,2.36-0.7,5.45-1.49,8.1
		C22.16,190.6,22.94,184.83,23.07,179.09z"
            />
          </g>
        </svg>
      </template>
    </template>
  </div>
</template>

<script>
import Icon from "@/assets/evaluation/flower/flower_7_3.svg";
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    len: {
      type: Number,
      required: true,
    },
  },
  components: {
    Icon,
  },
  data() {
    return {};
  },
  methods: {
    getImgSource() {
      if (path > 9) return;
      return require(`@/assets/evaluation/flower/flower_${this.name}.svg`);
    },
    clickHandle(index, type) {
      // console.log("被点击了", index, type);
      this.$emit("svgClickItem", index, type);
    },
  },
};
</script>

<style lang="scss">
$color_1: #fec737;
$color_2: #f35a55;
$color_3: #8697d0;
$color_4: #61dcd5;
$color_5: #23a072;
$color_6: #d3ea69;
$color_7: #f188c6;
$color_8: #fb8f41;
$color_9: #30ade8;

.flower_type {
  height: 100%;
  width: 100%;

  &_1 {
    width: 2rem;
    height: 2rem;
    animation-timing-function: linear;
    &_color1 {
      // fill: $color_1;

      // &:hover {
      //   fill: darken($color_1, 15%);
      // }

      // &:active {
      //   fill: darken($color_1, 40%);
      // }

      animation: color_1_1 2s infinite;
      // animation-direction: alternate-reverse;
      @keyframes color_1_1 {
        0% {
          fill: #fec737;
        }
        50% {
          fill: darken(#fec737, 15%);
        }
        100% {
          fill: darken(#fec737, 40%);
        }
      }
    }

    &_color2 {
      animation: color_1_2 2s infinite;
      @keyframes color_1_2 {
        0% {
          fill: darken($color_1, 15%);
        }
        50% {
          fill: darken($color_1, 40%);
        }
        100% {
          fill: $color_1;
        }
      }
    }

    &_color3 {
      animation: color_1_3 2s infinite;
      @keyframes color_1_3 {
        0% {
          fill: darken($color_1, 40%);
        }
        50% {
          fill: $color_1;
        }
        100% {
          fill: darken($color_1, 15%);
        }
      }
    }
  }

  &_2 {
    width: 2.2rem;
    height: 2.2rem;
    animation-timing-function: linear;
    // animation-direction: alternate-reverse;

    &_color1 {
      animation: color_2_1 2s infinite;
      @keyframes color_2_1 {
        0% {
          fill: $color_2;
        }
        50% {
          fill: darken($color_2, 15%);
        }
        100% {
          fill: darken($color_2, 40%);
        }
      }
    }

    &_color2 {
      animation: color_2_2 2s infinite;
      @keyframes color_2_2 {
        0% {
          fill: darken($color_2, 15%);
        }
        50% {
          fill: darken($color_2, 40%);
        }
        100% {
          fill: $color_2;
        }
      }
    }

    &_color3 {
      animation: color_2_3 2s infinite;
      @keyframes color_2_3 {
        0% {
          fill: darken($color_2, 40%);
        }
        50% {
          fill: $color_2;
        }
        100% {
          fill: darken($color_2, 15%);
        }
      }
    }
  }

  &_3 {
    width: 2rem;
    height: 2rem;

    // animation-timing-function: linear;
    animation-direction: reverse-alternate;

    &_color1 {
      animation: color_3_1 2s infinite;
      @keyframes color_3_1 {
        0% {
          fill: $color_3;
        }
        50% {
          fill: darken($color_3, 15%);
        }
        100% {
          fill: darken($color_3, 40%);
        }
      }
    }

    &_color2 {
      animation: color_3_2 2s infinite;
      @keyframes color_3_2 {
        0% {
          fill: darken($color_3, 15%);
        }
        50% {
          fill: darken($color_3, 40%);
        }
        100% {
          fill: $color_3;
        }
      }
    }

    &_color3 {
      animation: color_3_3 2s infinite;
      @keyframes color_3_3 {
        0% {
          fill: darken($color_3, 40%);
        }
        50% {
          fill: $color_3;
        }
        100% {
          fill: darken($color_3, 15%);
        }
      }
    }

    .cls-1,
    .cls-2,
    .cls-3,
    .cls-4,
    .cls-5 {
      stroke-width: 0px;
      fill: #8496cf;
    }

    .cls-2 {
      fill: #9ba9d7;
    }

    .cls-3 {
      fill: #c2cef6;
    }

    .cls-4 {
      fill: #a7b3da;
    }

    .cls-5 {
      fill: #8496cf;
    }
  }

  &_4 {
    width: 2rem;
    height: 2rem;
    animation-timing-function: linear;
    &_color1 {
      animation: color_4_1 2s infinite;
      // animation-direction: alternate-reverse;
      @keyframes color_4_1 {
        0% {
          fill: $color_4;
        }
        50% {
          fill: darken($color_4, 15%);
        }
        100% {
          fill: darken($color_4, 40%);
        }
      }
    }

    &_color2 {
      animation: color_4_2 2s infinite;
      @keyframes color_4_2 {
        0% {
          fill: darken($color_4, 15%);
        }
        50% {
          fill: darken($color_4, 40%);
        }
        100% {
          fill: $color_4;
        }
      }
    }

    &_color3 {
      animation: color_4_3 2s infinite;
      @keyframes color_4_3 {
        0% {
          fill: darken($color_4, 40%);
        }
        50% {
          fill: $color_4;
        }
        100% {
          fill: darken($color_4, 15%);
        }
      }
    }
  }

  &_5 {
    width: 2rem;
    height: 2rem;
    animation-timing-function: linear;
    &_color1 {
      animation: color_5_1 2s infinite;
      // animation-direction: alternate-reverse;
      @keyframes color_5_1 {
        0% {
          fill: $color_5;
        }
        50% {
          fill: darken($color_5, 15%);
        }
        100% {
          fill: darken($color_5, 40%);
        }
      }
    }

    &_color2 {
      animation: color_5_2 2s infinite;
      @keyframes color_5_2 {
        0% {
          fill: darken($color_5, 15%);
        }
        50% {
          fill: darken($color_5, 40%);
        }
        100% {
          fill: $color_5;
        }
      }
    }

    &_color3 {
      animation: color_5_3 2s infinite;
      @keyframes color_5_3 {
        0% {
          fill: darken($color_5, 40%);
        }
        50% {
          fill: $color_5;
        }
        100% {
          fill: darken($color_5, 15%);
        }
      }
    }
  }

  &_6 {
    width: 2.2rem;
    height: 2.2rem;
    animation-timing-function: linear;
    &_color1 {
      animation: color_6_1 2s infinite;
      // animation-direction: alternate-reverse;
      @keyframes color_6_1 {
        0% {
          fill: $color_6;
        }
        50% {
          fill: darken($color_6, 15%);
        }
        100% {
          fill: darken($color_6, 40%);
        }
      }
    }

    &_color2 {
      animation: color_6_2 2s infinite;
      @keyframes color_6_2 {
        0% {
          fill: darken($color_6, 15%);
        }
        50% {
          fill: darken($color_6, 40%);
        }
        100% {
          fill: $color_6;
        }
      }
    }

    &_color3 {
      animation: color_6_3 2s infinite;
      @keyframes color_6_3 {
        0% {
          fill: darken($color_6, 40%);
        }
        50% {
          fill: $color_6;
        }
        100% {
          fill: darken($color_6, 15%);
        }
      }
    }
  }

  &_7 {
    width: 2rem;
    height: 2rem;
    animation-timing-function: linear;
    &_color1 {
      animation: color_7_1 2s infinite;
      @keyframes color_7_1 {
        0% {
          fill: $color_7;
        }
        50% {
          fill: darken($color_7, 15%);
        }
        100% {
          fill: darken($color_7, 40%);
        }
      }
    }
    &_color2 {
      animation: color_7_2 2s infinite;
      @keyframes color_7_2 {
        0% {
          fill: darken($color_7, 15%);
        }
        50% {
          fill: darken($color_7, 40%);
        }
        100% {
          fill: $color_7;
        }
      }
    }
    &_color3 {
      animation: color_7_3 2s infinite;
      @keyframes color_7_3 {
        0% {
          fill: darken($color_7, 40%);
        }
        50% {
          fill: $color_7;
        }
        100% {
          fill: darken($color_7, 40%);
        }
      }
    }
  }

  &_8 {
    width: 2rem;
    height: 2rem;
    animation-timing-function: linear;
    &_color1 {
      animation: color_8_1 2s infinite;
      // animation-direction: alternate-reverse;
      @keyframes color_8_1 {
        0% {
          fill: $color_8;
        }
        50% {
          fill: darken($color_8, 15%);
        }
        100% {
          fill: darken($color_8, 40%);
        }
      }
    }

    &_color2 {
      animation: color_8_2 2s infinite;
      @keyframes color_8_2 {
        0% {
          fill: darken($color_8, 15%);
        }
        50% {
          fill: darken($color_8, 40%);
        }
        100% {
          fill: $color_8;
        }
      }
    }

    &_color3 {
      animation: color_8_3 2s infinite;
      @keyframes color_8_3 {
        0% {
          fill: darken($color_8, 40%);
        }
        50% {
          fill: $color_8;
        }
        100% {
          fill: darken($color_8, 15%);
        }
      }
    }
  }

  &_9 {
    width: 2rem;
    height: 2rem;
    animation-timing-function: linear;
    &_color1 {
      animation: color_9_1 2s infinite;
      // animation-direction: alternate-reverse;
      @keyframes color_9_1 {
        0% {
          fill: $color_9;
        }
        50% {
          fill: darken($color_9, 15%);
        }
        100% {
          fill: darken($color_9, 40%);
        }
      }
    }

    &_color2 {
      animation: color_9_2 2s infinite;
      @keyframes color_9_2 {
        0% {
          fill: darken($color_9, 15%);
        }
        50% {
          fill: darken($color_9, 40%);
        }
        100% {
          fill: $color_9;
        }
      }
    }

    &_color3 {
      animation: color_9_3 2s infinite;
      @keyframes color_9_3 {
        0% {
          fill: darken($color_9, 40%);
        }
        50% {
          fill: $color_9;
        }
        100% {
          fill: darken($color_9, 15%);
        }
      }
    }
  }
}


.st454 {
  fill: #f35a55;
}
.st455 {
  fill: #de2c27;
}
.st456 {
  fill: #f47d79;
}
.st457 {
  fill: #e5433f;
}
.st458 {
  fill: #e23d39;
}

.st43 {
  fill: #f35a55;
}
.st44 {
  fill: #de2c27;
}
.st64 {
  fill: #e3413c;
}
.st65 {
  fill: #e33d39;
}
.st471 {
  fill: #fec737;
}
.st472 {
  fill: #ecb117;
}
.st473 {
  fill: #fada85;
}
.st474 {
  fill: #fada84;
}
.st475 {
  fill: #fad87c;
}
.st445 {
  fill: $color_4;
}
.st446 {
  fill: #35c4bc;
}
.st447 {
  fill: #a9fbf6;
}
.st448 {
  fill: #36c5bd;
}
.st449 {
  fill: #3cc6bf;
}
.st450 {
  fill: #53d2cb;
}
.st422 {
  fill: #dff3ec;
}
.st423 {
  fill: #38b788;
}
.st424 {
  fill: #229f72;
}
.st425 {
  fill: #55d4a5;
}
.st426 {
  fill: $color_5;
}
.st427 {
  fill: #2fa67b;
}
.st428 {
  fill: #22a072;
}
.st19 {
  fill: $color_6;
}
.st20 {
  fill: #bfda41;
}
.st21 {
  fill: #effeab;
}
.st22 {
  fill: #c7e055;
}
.st23 {
  fill: #c7df53;
}
.st24 {
  fill: #c0db42;
}
.st0 {
  fill: $color_7;
}
.st1 {
  fill: #db5ea7;
}
.st2 {
  fill: #fdf8fb;
}
.st3 {
  fill: #f5aed8;
}
.st4 {
  fill: #f6b5db;
}
.st5 {
  fill: #e792c4;
}
.st6 {
  fill: #e774b8;
}
.st7 {
  fill: #f5b4db;
}
.st442 {
  fill: $color_8;
}
.st443 {
  fill: #e67521;
}
.st444 {
  fill: #e77724;
}

.st453 {
  fill: #feb178;
}
.st429 {
  fill: $color_9;
}
.st430 {
  fill: #1c9cd7;
}
.st431 {
  fill: #46b6ea;
}
.st432 {
  fill: #93d4f3;
}
.st433 {
  fill: #76d0fa;
}
.st434 {
  fill: #1c9dd7;
}
.st435 {
  fill: #2aa5de;
}

.st417 {
  fill: #a7b3da;
}
.st418 {
  fill: #8496cf;
}
.st468 {
  fill: #92a2d4;
}
.st465 {
  fill: #fbfcfd;
}

.st436 {
  fill: $color_6;
}
.st437 {
  fill: #bfda41;
}
.st463 {
  fill: #c8e057;
}
.st440 {
  fill: #c7df53;
}
.st438 {
  fill: #effeab;
}

.st419 {
  fill: #c2cef6;
}
.st469 {
  fill: #8799d0;
}

.st459 {
  fill: #feb179;
}
.st443 {
  fill: #e67521;
}

.st461 {
  fill: #f47e7a;
}
</style>
